import { Component, OnInit, ViewChild, EventEmitter, NgZone } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import * as Materialize from 'angular2-materialize/dist/index';
import { ProjectDataService } from '../shared/dataservice.service';
import { SharedService } from '../shared/shared.service';
import { CommonService } from '../navbar/searchCommon.service';
import { QuoteService } from './quote.service';
import * as globals from '../globals';
import { UtilsService } from '../shared/utils.service';
import { UploadService } from '../shared/upload.service';
import { ProjectsService } from '../projects/projects.service';
import { GetFileTypeService } from '../shared/getFileType/get-file-type.service';
import { S3CredService } from '../shared/s3-cred-service';
import { NavbarService } from '../navbar/navbar.service';
import { DatePipe } from '@angular/common';
import { ClipboardModule } from 'ngx-clipboard';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Rx';

import { AdvancedSearchChipsComponent } from '../search/chips/searchchips.component';

declare var html2canvas: any;
declare let jsPDF;
declare var saveAs: any;
declare let PDFJS;
declare let jQuery: any;
declare let openNewBrowserWindow: any;
declare let openNewBrowserWindow2: any;

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.css'],
  providers: [ProjectsService, QuoteService, S3CredService, DatePipe]
})



export class QuoteComponent implements OnInit {

  waiticon: string;
  email: string;
  planid: string;
  customersDict: any = [];
  customersWithcustomerContactsDict: any = [];
  parentProject: any;
  selctedCustomer: any = [];
  selctedCustomerContact: any = [];
  selctedOwner: any = [];
  // Store get Quote API return data
  owners: any = [];
  quotes: any = [];
  quoteprojects: any = [];
  quoteprojectquantities: any = [];
  quoteprojectstatuses: any = [];
  leadtimeunits: any = [];
  quoteprojectordertypes: any = [];
  quotestatuses: any = [];
  comments: any = [];
  commenttypes: any = [];
  shipvias: any = [];
  quoteterms: any = [];
  users: any = [];
  customers: any = [];
  customerContacts: any = [];
  projects: any = [];
  selectedProjects: any = [];
  temproryselectedProjects: any = [];
  defaultMargin = 30;
  chip: string;
  noQuotes: boolean;
  loadingprojects: boolean;
  loadingquotes: boolean;
  newQuoteSelctedCustomerId: number;
  quotedata: boolean;
  newQuotedata: boolean = false;
  recipedata: boolean;
  currentControl: any;
  numberofDaysSearch: number;
  selectedQuoteId: number;
  selectedQuoteNumberId: number;
  selectedQuote: any = {};
  customerQinfo_id: number;
  customercontactQinfo_id: number;
  shipviaQinfo_id: number;
  quoteTermQinfo_id: number;
  selectedQuoteProject: any;
  quoteeditMode: boolean;
  newQuoteButtonStatus: boolean = true;

  // excludeNREEdit_NRE_value_Dict = [];
  amortizeREEdit_NRE_value_Dict = [];
  quotepdfprint: any = {};

  // Pagination
  public filter: string = '';
  public filter1: string = '';
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public config = {
    itemsPerPage: 25,
    currentPage: 1,
    totalItems: 1
  }; // Pagination
  public quoteconfig = {
    itemsPerPage: 5,
    currentPage: 1,
    totalItems: 1
  }; // Pagination

  // Advanced search variables
  projectNameSearch: string;
  customerselectSearchString: string;
  customerSearch: string = '';
  partNumberSearch: string = '';
  revisionSearch: string = '';
  materialArray: any = [];
  statusSelectSearchString: string = '';
  materialselectSearchString: string;
  ownerSelectSearchString: string;
  dateRangeString: string;
  createdDateSearch: string;
  statusArray: any = ['', 'OPEN', 'WIP', 'REVIEW', 'APPROVED', 'MADE'];
  dateRangeArray: any = ['1 week', '2 weeks', '1 month', '2 months', '6 months', '1 year'];
  materialselect: number;
  materialselectSearch: number;
  ownerselect: number;
  ownerselectSearch: number;
  customerselect: number;
  customerselectSearch: number;
  statusselect: number;
  statusselectSearch: number;
  chipArray = [];
  public advancedSearchJSONbody = {};
  searchTerms: any;
  emptySearchProjects: boolean;
  noProjects: boolean;
  projectforceUpdate: boolean;
  tenantid: string = '';
  localRecipies = [];
  selctedLocalRecipe: number;
  tenanturl: string;
  ownerDict: any = [];
  ownerPhoneDict: any = [];
  customerDict: any = [];
  customercontactDict: any = [];
  customersAddress1Dict: any = [];
  customersAddress2Dict: any = [];
  customersCityDict: any = [];
  customerStateDict: any = [];
  customerZipDict: any = [];
  shipviaDict: any = [];
  quotetermDict: any = [];
  quotestatusesDict: any = [];
  customerContactsDict: any = [];
  customerContactEmailDict: any = [];
  customerContactPhoneDict: any = [];
  quoteprojectordertypesDict: any = [];
  quoteprojectsDict: any = [];
  quoteprojectquantitiesDict: any = [];
  projectRecipeDict: any = [];
  recipeDict: any = [];
  materialDict: any = [];
  quoteDict: any = [];
  currentCustomer: number;
  isEditAdvancedSearch: boolean;
  currentlySelctedRecipeId: number;
  validPDF = '';
  commentsDict: any = [];
  commentQuoteDict: any = [];
  selectedQuotesProjectsCount: number = 0;
  LoadedSelectedProjectsCount: number = 0;
  showCreateQuoteButton: boolean = false;
  canvasdiv: any;
  canvasContext: any;
  loadingpdfPreview: boolean = false;
  public dateFormat: string;
  quote_contact_info: string;
  quote_document_footer: string;
  public currencySymbol: string;
  public currencyName: string;
 public needbydatePlaceholder: string;

  private bucketname = globals.BUCKETNAME;

  public filteredMaterialList = [];
  public filteredCustomerList = [];
  public filteredOwnerList = [];

  // variables below were added to get the build passing they were already being used in the template
  // Edit errors were present on line 80 HTML
  Edit: any;
  // editApply errors were present on line 94 HTML
  editApply: any;
  // editCancel errors were present on line 95 HTML
  editCancel: any;
  // quoteActions errors were present on line 98 HTML
  quoteActions: any;
  // temporary add until development of component is finished
  uploadingProject = false;

  quoteindextodelete = 0;

  projectid: any;

  private subscription: Subscription;

  haveAdvancedSearch: boolean = false;
  quoteloaderror: boolean = false;

  errorMessage = '';
  noresultsmessage: string = 'No Quote Number or RFQ contains:';

  noresultsmessageAdvancedSearch: string = 'No Quote found with above search terms';
  ContextOwnerID: number;


  modalNewQuoteAction = new EventEmitter<string | MaterializeAction>();
  modalAddLineItemAction = new EventEmitter<string | MaterializeAction>();
  modalEditQuantityAction = new EventEmitter<string | MaterializeAction>();
  modalEditQuoteAction = new EventEmitter<string | MaterializeAction>();
  modalAdvancedSearchProjectsAction = new EventEmitter<string | MaterializeAction>();
  modalDeleteQuoteAction = new EventEmitter<string | MaterializeAction>();
  modalDeleteQuoteProjectAction = new EventEmitter<string | MaterializeAction>();
  modalDeleteWarningQuoteProjectAction = new EventEmitter<string | MaterializeAction>();

  constructor(
    private uploadService: UploadService,
    private projectsService: ProjectsService,
    private router: Router,
    private route: ActivatedRoute,
    private service: SharedService,
    public quoteService: QuoteService,
    private ngZone: NgZone,
    private projectDataService: ProjectDataService,
    private utilsService: UtilsService,
    private getFileTypeService: GetFileTypeService,
    private s3CredService: S3CredService,
    public navService: NavbarService,
    private commonService: CommonService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    if (this.router.url !== '/workspace') {
      this.navService.show('QUOTES');
      this.navService.setNavID(8);
    }

    this.loadingquotes = true;
    this.dateFormat = localStorage.getItem('mr_date_format_id');
    this.quote_contact_info = localStorage.getItem('mr_quote_contact_info');
    this.quote_document_footer = localStorage.getItem('mr_quote_document_footer');
    this.currencySymbol = localStorage.getItem('mr_currency_symbol');
    this.currencyName = localStorage.getItem('mr_currency_id');
    this.planid = localStorage.getItem('mr_planid');

    this.subscription = this.commonService.notifyObservable$.subscribe((res) => {
      if (res.hasOwnProperty('option') && res.option === 'onSearchFromNav') {

        console.log('search', res.value);

        if (res.value.page === 'quotes') {
          this.emptySearchProjects = false;
          this.haveAdvancedSearch = false;
          this.searchTerms = res.value.data;
          if (isNaN(this.searchTerms)) {
            this.advancedSearchJSONbody = { RFQ: this.searchTerms };
          } else {
            this.advancedSearchJSONbody = { number: Number(this.searchTerms), RFQ: this.searchTerms };
          }
          this.projectDataService.setForceUpdateBool(true);
          this.advancedSearchQuote(this.advancedSearchJSONbody, 0); // 0 for basic search
        }


      } else {
        if (res.hasOwnProperty('option') && res.option === 'onAdvancedSearch') {

          if (res.value.page === 'quotes') {
            this.emptySearchProjects = false;
            this.haveAdvancedSearch = true;
            this.advancedSearchJSONbody = res.value.data;
            this.projectDataService.setForceUpdateBool(true);
            this.advancedSearchQuote(this.advancedSearchJSONbody);
          }
        }
      }
    });

    if (this.planid === '3') {
      this.tenanturl = globals.GOVTENANTURL;
    } else {
      this.tenanturl = globals.TENANTURL;
    }

    if (typeof this.planid == 'undefined' || this.planid === '') {
      this.planid = '1';
    }

    if (this.planid === '3') {
      this.tenanturl = globals.GOVTENANTURL;
    } else {
      this.tenanturl = globals.TENANTURL;
    }

    console.log('TENANTURL:', this.tenanturl);

    this.projectid = +this.route.snapshot.paramMap.get('id');
    console.log('project id: ', this.projectid);

    this.tenantid = localStorage.getItem('mr_tenantid');
    this.quoteconfig.currentPage = 1;
    this.quoteconfig.itemsPerPage = 10;

    this.service.getCorporateInfo().subscribe(
      data => {
        let jdata = JSON.parse(data);
        this.customers = jdata.customers;
        this.materialArray = jdata.materials;
        this.owners = jdata.owners;

        this.email = localStorage.getItem('mr_email');
        if (this.owners) {
          for (let i = 0; i < this.owners.length; i++) {
            this.ownerDict[this.owners[i].id] = this.owners[i].email;
            if (this.email === this.owners[i].email) {
              this.ContextOwnerID = this.owners[i].id;
            }
          }
        }

        if (this.router.url === '/workspace') {
          this.service.setQuoteSearchResultBool(true);
          this.service.setSearchResultData('quotes', {owner : this.ContextOwnerID});
          document.getElementById('quoteList').style.marginTop = '-20px';
          document.getElementById('quoteList').style.paddingLeft = '0px';
          document.getElementById('quoteList').style.width = '100%';
        }


        // if we navigate from the project page via the Quote It for a specific project
        if (this.projectid != 0) {

          this.service.getProjectDetailsById(this.projectid).subscribe(
            data => {
              let parseddata = JSON.parse(data);
              console.log('PARSEDDATA:', parseddata);
              this.parentProject = parseddata.project;

              for (let i = 0; i < this.materialArray.length; i++) {
                this.materialDict[this.materialArray[i].id] = this.materialArray[i].name;
              }

              let filenamenoext = this.parentProject.filename.replace(/\.[^/.]+$/, '');
              if (!filenamenoext) {
                filenamenoext = ' ';
              }
              // Determine the Model Type to show - based on the file extension
            this.parentProject.modeltype = this.utilsService.getModelName(this.parentProject.modeltype_id);

            if (this.parentProject.modeltype != 0) {
              this.parentProject.thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.parentProject.id + '/' + filenamenoext + '_320x240.png';
            } else {
              let ext = this.parentProject.extension.toLowerCase();
              console.log('EXTENSION:', ext);
              this.parentProject.thumbnail = this.getFileTypeService.returnFileTypeExtensionURLAppend96(ext);
            }

            let mr_recipedata = localStorage.getItem('mr_recipedata_For_Quote_From_Recipe');

              if (mr_recipedata === 'true') {

                let mr_material = localStorage.getItem('mr_material');


                localStorage.setItem('mr_recipedata_For_Quote_From_Recipe', 'false');

              let recipies = localStorage.getItem('mr_recipe_For_Quote_From_Recipe');
              this.localRecipies = JSON.parse(recipies);
              let selectedRecipe = localStorage.getItem('mr_defauldRecipe_For_Quote_From_Recipe');
                this.selctedLocalRecipe = Number(selectedRecipe); // JSON.parse(recipies);

                localStorage.setItem('mr_recipe_For_Quote_From_Recipe', '');
                localStorage.setItem('mr_defauldRecipe_For_Quote_From_Recipe', '');

                this.recipedata = true;
              } else {
                this.quotedata = true;
              }
              this.refreshQuote();
            },
            error => {
              console.error('getProjectDetailsById error: ', error);
            }
          );
        } else {

          if (this.router.url === '/workspace') {
            this.service.setQuoteSearchResultBool(false);
            this.commonService.notifyOther({ option: 'getPageSearchData', value: 'quotes'});
          } else {
            let timer = Observable.timer(1500); // Delay to get chip showing when coming from a different page
            timer.subscribe(t => {
              // check if this page was loaded by a search query
              if (this.service.getQuoteSearchResultBool()) {
                this.service.setQuoteSearchResultBool(false);
                this.commonService.notifyOther({ option: 'getPageSearchData', value: 'quotes'});
              } else {
                this.refreshQuote();
              }
            });
          }
        }
      },
    error => {
      console.error('getCorporateInfo error: ', error);
    }
  );
  }

  ngOnDestroy() {
    this.modalNewQuoteAction.emit({ action: 'modal', params: ['close'] });
    this.modalAddLineItemAction.emit({ action: 'modal', params: ['close'] });
    this.modalEditQuantityAction.emit({ action: 'modal', params: ['close'] });
    this.modalEditQuoteAction.emit({ action: 'modal', params: ['close'] });
    this.modalAdvancedSearchProjectsAction.emit({ action: 'modal', params: ['close'] });
    this.modalDeleteQuoteAction.emit({ action: 'modal', params: ['close'] });
    this.modalDeleteQuoteProjectAction.emit({ action: 'modal', params: ['close'] });
    this.modalDeleteWarningQuoteProjectAction.emit({ action: 'modal', params: ['close'] });
}

  refreshQuote() {
    this.noQuotes = false;
    this.getQuotes();
  }

  editQuantityModal(qouteProjectindex, quoteproject) {

    let recipeId = quoteproject.recipeConnectingID;
    this.recipeDict[recipeId].temporaryQuantityBreakDown = [];
    this.recipeDict[recipeId].temporaryAmortize_nre = this.recipeDict[recipeId].amortize_nre;
    this.recipeDict[recipeId].temporaryExclude_nre = this.recipeDict[recipeId].exclude_nre;

    for (let i = 0; i < this.recipeDict[recipeId].quantityBreakDown.length; i++) {
      this.recipeDict[recipeId].temporaryQuantityBreakDown.push({
        index: this.recipeDict[recipeId].quantityBreakDown[i].index,
        quantity: this.recipeDict[recipeId].quantityBreakDown[i].quantity,
        unit_price: this.recipeDict[recipeId].quantityBreakDown[i].unit_price,
        nre_price: this.recipeDict[recipeId].quantityBreakDown[i].nre_price,
        margin: this.recipeDict[recipeId].quantityBreakDown[i].margin,
        lead_time: this.recipeDict[recipeId].quantityBreakDown[i].lead_time,
        amount: this.recipeDict[recipeId].quantityBreakDown[i].amount
      });
    }
    this.editQuantityBreakDownDetailsEditmode(qouteProjectindex, quoteproject);
  }


  editQuantityBreakDownDetailsEditmode(qouteProjectindex, quoteproject) {

    quoteproject.editmode = true;

    document.getElementById('editQuoteproject_Edit' + qouteProjectindex).style.display = 'none';
    document.getElementById('editQuoteproject_remove' + qouteProjectindex).style.display = 'none';
    document.getElementById('quoteprojectquantityEdit' + qouteProjectindex).style.display = 'none';
    document.getElementById('quoteprojectquantityApply' + qouteProjectindex).style.display = 'inline-block';
    document.getElementById('quoteprojectquantityCancel' + qouteProjectindex).style.display = 'inline-block';


    (<HTMLInputElement>document.getElementById('editquoteprojectExclude_nre' + qouteProjectindex)).disabled = false;
    (<HTMLInputElement>document.getElementById('editquoteprojectAmortize_nre' + qouteProjectindex)).disabled = false;
    (<HTMLInputElement>document.getElementById('editquantityBreakDownAdd' + qouteProjectindex)).disabled = false;


    if ((<HTMLInputElement>document.getElementById('editquoteprojectExclude_nre' + qouteProjectindex)).checked) {
      (<HTMLInputElement>document.getElementById('editquoteprojectAmortize_nre' + qouteProjectindex)).disabled = true;
    } else {
      (<HTMLInputElement>document.getElementById('editquoteprojectAmortize_nre' + qouteProjectindex)).disabled = false;
    }

    if ((<HTMLInputElement>document.getElementById('editquoteprojectAmortize_nre' + qouteProjectindex)).checked) {
      (<HTMLInputElement>document.getElementById('editquoteprojectExclude_nre' + qouteProjectindex)).disabled = true;
    } else {
      (<HTMLInputElement>document.getElementById('editquoteprojectExclude_nre' + qouteProjectindex)).disabled = false;
    }

  }


  saveQuantityModal(qouteProjectindex, quoteproject) {

    let recipeId = quoteproject.recipeConnectingID;
    document.getElementById('quoteprojectquantityUpdating' + qouteProjectindex).style.display = 'block';
    document.getElementById('quoteprojectquantityApply' + qouteProjectindex).style.display = 'none';
    document.getElementById('quoteprojectquantityCancel' + qouteProjectindex).style.display = 'none';

    let quoteprojectquantities = [];

    for (let quantityBreakDown of this.recipeDict[recipeId].quantityBreakDown) {

      let quoteprojectquantity = {
        quantity: quantityBreakDown.quantity,
        unit_price: quantityBreakDown.unit_price,
        nre_price: quantityBreakDown.nre_price,
        margin: quantityBreakDown.margin,
        lead_time: quantityBreakDown.lead_time,
      };

      quoteprojectquantities.push(quoteprojectquantity);
    }

    let updateQuoteProject = {
      id: quoteproject.id,
      exclude_nre: this.recipeDict[recipeId].exclude_nre,
      amortize_nre: this.recipeDict[recipeId].amortize_nre,
    };

    this.quoteService.updateQuoteProject(updateQuoteProject, quoteprojectquantities)
      .subscribe(
      data => {
        let neqQuantityBreakdown = JSON.parse(data);

        Materialize.toast('QUANTITY BREAK DOWN UPDATED SUCCESSFULLY', 1500);
        this.SelectedQuoteUpdated();
        this.endEditQuantityModel(qouteProjectindex, quoteproject);
        this.updateQuantityBreakdownVariables(quoteproject, this.recipeDict[recipeId].quantityBreakDown, neqQuantityBreakdown, updateQuoteProject );
      },
      error => {
        Materialize.toast('SERVER ISSUE - PLEASE TRY AGAIN', 1500);
        console.log('SERVER ISSUE - PLEASE TRY AGAIN');
        this.endEditQuantityModel(qouteProjectindex, quoteproject);
      });
  }

  updateQuantityBreakdownVariables(quoteproject: any, quantityBreakDown: any, neqQuantityBreakdown: any, updateQuoteProject: any) {

    quoteproject.quoteprojectquantities = [];
    quoteproject.exclude_nre = updateQuoteProject.exclude_nre;
    quoteproject.amortize_nre = updateQuoteProject.amortize_nre;

    for (let k = 0; k < neqQuantityBreakdown.quoteprojectquantities.length; k++) {
      quoteproject.quoteprojectquantities.push(neqQuantityBreakdown.quoteprojectquantities[k].id);
      this.quoteprojectquantities.push(neqQuantityBreakdown.quoteprojectquantities[k]);
    }

    for (let i = 0; i < this.quoteprojectquantities.length; i++) {
      this.quoteprojectquantities[i].amount = ((this.quoteprojectquantities[i].unit_price * this.quoteprojectquantities[i].quantity) + this.quoteprojectquantities[i].nre_price);
      this.quoteprojectquantities[i].exclude_nre = updateQuoteProject.exclude_nre;
      this.quoteprojectquantities[i].amortize_nre = updateQuoteProject.amortize_nre;
      this.quoteprojectquantitiesDict[this.quoteprojectquantities[i].id] = this.quoteprojectquantities[i];
    }

  }

  cancelQuantityModal(qouteProjectindex, quoteproject) {

    let recipeId = quoteproject.recipeConnectingID;
    if (this.recipeDict[recipeId].temporaryQuantityBreakDown) {
      this.recipeDict[recipeId].quantityBreakDown = [];

      this.recipeDict[recipeId].amortize_nre = this.recipeDict[recipeId].temporaryAmortize_nre;
      this.recipeDict[recipeId].exclude_nre = this.recipeDict[recipeId].temporaryExclude_nre;

      if (this.recipeDict[recipeId].amortize_nre) {
        (<HTMLInputElement>document.getElementById('editquoteprojectAmortize_nre' + qouteProjectindex)).checked = true;
      } else {
        (<HTMLInputElement>document.getElementById('editquoteprojectAmortize_nre' + qouteProjectindex)).checked = false;
      }

      if (this.recipeDict[recipeId].exclude_nre) {
        (<HTMLInputElement>document.getElementById('editquoteprojectExclude_nre' + qouteProjectindex)).checked = true;
      } else {
        (<HTMLInputElement>document.getElementById('editquoteprojectExclude_nre' + qouteProjectindex)).checked = false;
      }

      for (let i = 0; i < this.recipeDict[recipeId].temporaryQuantityBreakDown.length; i++) {
        this.recipeDict[recipeId].quantityBreakDown.push({
          index: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].index,
          quantity: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].quantity,
          unit_price: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].unit_price,
          nre_price: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].nre_price,
          margin: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].margin,
          lead_time: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].lead_time,
          amount: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].amount
        });
      }
    }

    this.endEditQuantityModel(qouteProjectindex, quoteproject);
  }

  endEditQuantityModel(qouteProjectindex, quoteproject) {

    document.getElementById('editQuoteproject_Edit' + qouteProjectindex).style.display = 'inline-block';
    document.getElementById('editQuoteproject_remove' + qouteProjectindex).style.display = 'inline-block';

    quoteproject.editmode = false;

    (<HTMLInputElement>document.getElementById('editquoteprojectExclude_nre' + qouteProjectindex)).disabled = true;
    (<HTMLInputElement>document.getElementById('editquoteprojectAmortize_nre' + qouteProjectindex)).disabled = true;
    (<HTMLInputElement>document.getElementById('editquantityBreakDownAdd' + qouteProjectindex)).disabled = true;

    document.getElementById('quoteprojectquantityUpdating' + qouteProjectindex).style.display = 'none';
    document.getElementById('quoteprojectquantityEdit' + qouteProjectindex).style.display = 'block';

    document.getElementById('quoteprojectquantityApply' + qouteProjectindex).style.display = 'none';
    document.getElementById('quoteprojectquantityCancel' + qouteProjectindex).style.display = 'none';
  }

  addProjectData() {

    console.log('addProjectData to Quote Project');

    let isProcessing = false;
    // Populate the thumbnail URLs
    for (let key in this.quoteprojects) {

      if (this.quoteprojects[key].upload_status == 1) {
        isProcessing = true;
      }

      let filenamenoext = ' ';

      // Get the filename extension
      this.quoteprojects[key].extension = '';
      if (this.quoteprojects[key].filename != null) {
        this.quoteprojects[key].extension = this.quoteprojects[key].filename.split('.').pop();

        // Get the filename without the extension
        filenamenoext = this.quoteprojects[key].filename.replace(/\.[^/.]+$/, '');
        filenamenoext = filenamenoext.replace(/[+]/g, '%2B');
      }

      if (this.quoteprojects[key].material_id == null || this.quoteprojects[key].material_id == 'undefined') {
        this.quoteprojects[key].material_id = 0;
      }

      this.quoteprojects[key].status_id = 0;
      this.quoteprojects[key].filenamenoext = filenamenoext;

      let modeltype = this.utilsService.determineModelType(this.quoteprojects[key].filename);

      if (this.quoteprojects[key].modeltype_id == 0 && modeltype != 0) {
        this.quoteprojects[key].modeltype_id = modeltype;
      }

      if (modeltype != 0) {
        this.quoteprojects[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.quoteprojects[key].project_id + '/' + filenamenoext + '_320x240.png';
      } else {
        let ext = this.quoteprojects[key].extension.toLowerCase();
        console.log('EXTENSION:', ext);
        this.quoteprojects[key].thumbnail = this.getFileTypeService.returnFileTypeExtensionURL(ext);
      }
    }
  }


  getQuotes() {
    this.quoteService.getQuotes(this.quoteconfig)
      .subscribe(
      data => {
        console.log('Got Quotes');
        this.LoadedSelectedProjectsCount = 0;
        let result = JSON.parse(data);
        console.log('Recipes : ', result);
        this.quotes = result.quotes;
        this.customers = result.customers;
        this.customerContacts = result.customercontacts;
        this.quotes = result.quotes;
        this.owners = result.owners;
        this.materialArray = result.materials;
        this.quoteprojects = result.quoteprojects;
        this.quoteprojectquantities = result.quoteprojectquantities;
        this.quoteprojectstatuses = result.quoteprojectstatuses;
        this.leadtimeunits = result.leadtimeunits;
        this.quoteprojectordertypes = result.quoteprojectordertypes;
        this.quotestatuses = result.quotestatuses;
        this.comments = result.comments;
        this.commenttypes = result.commenttypes;
        this.shipvias = result.shipvia;
        this.quoteterms = result.quoteterms;

        this.quoteconfig.currentPage = Number(result.pagenum);
        this.quoteconfig.totalItems = Number(result.count);

        this.addProjectData();

        for (let i = 0; i < this.materialArray.length; i++) {
          this.materialDict[this.materialArray[i].id] = this.materialArray[i].name;
        }

        for (let i = 0; i < this.quotes.length; i++) {
          this.quotes[i].updated = 0;
          this.quoteDict[this.quotes[i].id] = this.quotes[i];
        }

        for (let i = 0; i < this.owners.length; i++) {
          this.ownerDict[this.owners[i].id] = this.owners[i].firstname + ' ' + this.owners[i].lastname;
          this.ownerPhoneDict[this.owners[i].id] = this.owners[i].phone;
        }

        for (let i = 0; i < this.customers.length; i++) {
          this.customerDict[this.customers[i].id] = this.customers[i].name;
          this.customercontactDict[this.customers[i].id] = this.customers[i].primary_contact_id;
          this.customersAddress1Dict[this.customers[i].id] = this.customers[i].address;
          this.customersAddress2Dict[this.customers[i].id] = this.customers[i].address2;
          this.customersCityDict[this.customers[i].id] = this.customers[i].city;
          this.customerStateDict[this.customers[i].id] = this.customers[i].state;
          this.customerZipDict[this.customers[i].id] = this.customers[i].zip;
        }

        for (let i = 0; i < this.quotestatuses.length; i++) {
          this.quotestatusesDict[this.quotestatuses[i].id] = this.quotestatuses[i].name;
        }

        for (let i = 0; i < this.customerContacts.length; i++) {
          this.customerContactsDict[this.customerContacts[i].id] = this.customerContacts[i].firstname + ' ' + this.customerContacts[i].lastname;
          this.customerContactEmailDict[this.customerContacts[i].id] = this.customerContacts[i].email;
          this.customerContactPhoneDict[this.customerContacts[i].id] = this.customerContacts[i].phone;
        }

        for (let i = 0; i < this.quoteprojectordertypes.length; i++) {
          this.quoteprojectordertypesDict[this.quoteprojectordertypes[i].id] = this.quoteprojectordertypes[i].name;
        }

        for (let i = 0; i < this.shipvias.length; i++) {
          this.shipviaDict[this.shipvias[i].id] = this.shipvias[i].name;
        }

        for (let i = 0; i < this.quoteterms.length; i++) {
          this.quotetermDict[this.quoteterms[i].id] = this.quoteterms[i].name;
        }

        let customerContactsArray = [];

        for (let i = 0; i < this.customers.length; i++) {
          this.customersDict[this.customers[i].id] = this.customers[i];

          for (let j = 0; j < this.customerContacts.length; j++) {

                if (this.customerContacts[j].customer_id == this.customers[i].id) {
                          customerContactsArray.push(this.customerContacts[j]);
                        }
                 }
           this.customersWithcustomerContactsDict[this.customers[i].id] = customerContactsArray;
           customerContactsArray = [];
        }

        for (let i = 0; i < this.quoteprojectquantities.length; i++) {
          this.quoteprojectquantities[i].amount = ((this.quoteprojectquantities[i].unit_price * this.quoteprojectquantities[i].quantity) + this.quoteprojectquantities[i].nre_price);
          this.quoteprojectquantities[i].exclude_nre = 0;
          this.quoteprojectquantities[i].amortize_nre = 0;
          this.quoteprojectquantitiesDict[this.quoteprojectquantities[i].id] = this.quoteprojectquantities[i];
        }

        let quoteProjectsArray = [];

        for (let i = 0; i < this.quotes.length; i++) {
          for (let j = 0; j < this.quoteprojects.length; j++) {

            if (this.quoteprojects[j].quote_id == this.quotes[i].id) {
              quoteProjectsArray.push(this.quoteprojects[j]);
            }
          }
          this.quoteprojectsDict[this.quotes[i].id] = quoteProjectsArray;
          quoteProjectsArray = [];
        }

        for (let i = 0; i < this.comments.length; i++) {
          this.commentsDict[this.comments[i].id] = this.comments[i];
        }

        // temp values
        this.quotestatusesDict[0] = 'Unknown';
        this.ownerDict[0] = 'Unknown';
        this.quoteprojectordertypesDict[0] = 'Unknown';

        this.loadingquotes = false;

        for (let i = 0; i < this.quotes.length; i++) {

          if (this.quoteprojectsDict[this.quotes[i].id].length) {
            this.quotes[i].thumbnail = this.quoteprojectsDict[this.quotes[i].id][0].thumbnail;
          } else {
            this.quotes[i].thumbnail = '../assets/images/doctypes/pdf.png';
          }
        }

        if (this.quotedata) {
          this.quotedata = false;
          this.openmodalNewQuoteWithProjectLocalContent();
        } else {
          if (this.recipedata) {
            this.recipedata = false;
            this.openmodalNewQuoteWithRecipeLocalContent();
          }
        }

        if (this.newQuotedata) {
          this.ngZone.onMicrotaskEmpty.first().subscribe(() => {

            this.openmodalEditQuote(this.quotes[0]);
          });
        }
      },
      error => {
        this.loadingquotes = false;
      });
  }

  onQuotePageChange(number: number) {
    console.log('change to page', number);
    this.quoteconfig.currentPage = number;
    this.loadingquotes = true;
    this.quotes = [];
    this.refreshQuote();
  }

  onCustomerSelect(number: number) {
    console.log('change to page', number);
    this.newQuoteSelctedCustomerId = number;

    if (this.customersWithcustomerContactsDict[this.newQuoteSelctedCustomerId].length > 0 ) {
    this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
      (<HTMLInputElement>document.getElementById('quoteSelectedCustomerContactId')).value = this.customersWithcustomerContactsDict[this.newQuoteSelctedCustomerId][0].id;
    });
    }
  }

  // Special case if no recipe is present for the project.
  setRecipeData(recipes, project, project_id: number, newrecipe: boolean, ) {

    console.log('Recipes : ', recipes);
    this.projectRecipeDict[project_id] = recipes;
    let quantityBreakDown = [];

    project.projectEdit = true;
    project.newProject = true;
    for (let i = 0; i < recipes.length; i++) {
      let connectingID = this.getRecipeDictconnectingID(recipes[i].id, project);
      quantityBreakDown.push(this.addQuantityBreakDown(0, 1, recipes[i].unit_cost, recipes[i].nre_cost, project.margin, recipes[i].lot_cost));
      this.recipeDict[connectingID] = { recipe: recipes[i], quantityBreakDown: quantityBreakDown, exclude_nre: 0, amortize_nre: 0, default_margin: project.margin };
      quantityBreakDown = [];
    }

    project.loadingQuoteprojects = true;
    this.LoadedSelectedProjectsCount++;
    if (this.LoadedSelectedProjectsCount == this.selectedQuotesProjectsCount) {
      this.LoadedSelectedProjectsCount = 0;
      this.selectedQuotesProjectsCount = 0;
      this.showCreateQuoteButton = true;
    }
  }

  addEditableRecipe(project, project_id: number, newrecipe: boolean) {

    let quantityBreakDown = [];
    let id = project.id * -1;
    if (newrecipe) {
      let recipe = {
        id: id,
        name: 'No Recipe',
        lot_cost: 0,
        unit_cost: 0,
        nre_cost: 0,
      };

      let connectingID = this.getRecipeDictconnectingID(recipe.id, project);

      this.projectRecipeDict[project_id].push(recipe);

      project.projectEdit = true;
      project.newProject = true;
      project.defaultRecipe = recipe.id;
      project.recipeConnectingID = connectingID;

      quantityBreakDown.push(this.addQuantityBreakDown(0, 1, recipe.unit_cost, recipe.nre_cost, project.margin, recipe.lot_cost));
      this.recipeDict[connectingID] = { recipe: recipe, quantityBreakDown: quantityBreakDown, exclude_nre: 0, amortize_nre: 0, default_margin: project.margin };
      quantityBreakDown = [];
    } else {

      project.projectEdit = false;
      project.newProject = false;
      project.defaultRecipe = project.recipe_id;

      for (let j = 0; j < project.quoteprojectquantities.length; j++) {
        quantityBreakDown.push(this.quoteprojectquantitiesDict[project.quoteprojectquantities[j].id]);
      }
      let id = project.id * -1;

      let recipe = {
        id: id,
        name: 'No Recipe',
        lot_cost: project.recipe_lot_cost,
        unit_cost: project.recipe_unit_cost,
        nre_cost: project.recipe_nre_cost,
      };
      let connectingID = this.getRecipeDictconnectingID(recipe.id, project);
      project.recipeConnectingID = connectingID;

      this.projectRecipeDict[project_id].push(recipe);
      this.recipeDict[connectingID] = { recipe: recipe, quantityBreakDown: quantityBreakDown, exclude_nre: project.exclude_nre, amortize_nre: project.amortize_nre, default_margin: project.margin };
    }
  }

  getNnumberofZeros(number: number) {
    let result = 10;

    for (let i = 1 ; i < number ; i++) {
      result = result * 10;
    }
    return result;
  }

  getRecipeDictconnectingID(recipeId: number, project: any ) {
    let connectingID ;
    if (recipeId < 0) {
      recipeId = recipeId * -1;
      let digit =   recipeId.toString().length;
      connectingID  = project.referenceCountNumber * this.getNnumberofZeros(digit) +  recipeId;
      connectingID = connectingID * -1;
    } else {

       let digit =   recipeId.toString().length;
       connectingID  = project.referenceCountNumber * this.getNnumberofZeros(digit) +  recipeId;
    }

    return connectingID;
  }

  getRecipe(project, project_id: number, newrecipe: boolean, index: number) {

    this.quoteService.getRecipesProject(project_id)
      .subscribe(
      data => {

        console.log('Got Recipes');
        let result = JSON.parse(data);
        let recipes = result.recipes;
        console.log('Recipes : ', recipes);
        this.projectRecipeDict[project_id] = recipes;
        let quantityBreakDown = [];

        let recipematerials = result.recipematerials;
        let recipematerialsDict = [];
        for (let i = 0; i < recipematerials.length; i++) {
          recipematerialsDict[recipematerials[i].id] = recipematerials[i].material_id;
        }

        if (newrecipe) {
          project.projectEdit = true;
          project.newProject = true;
          for (let i = 0; i < recipes.length; i++) {

            let connectingID = this.getRecipeDictconnectingID(recipes[i].id, project);

            if (recipes[i].is_default) {
              project.defaultRecipe = recipes[i].id;
              project.recipeConnectingID = connectingID;
            }

            if (recipematerialsDict.length > 0) {
              if (recipes[i].recipematerials > 0) { // check if there is a material for the recipe
                let material_id = recipematerialsDict[recipes[i].recipematerials[0].id];
                recipes[i].material_id = material_id;
              }

            }

            quantityBreakDown.push(this.addQuantityBreakDown(0, 1, recipes[i].unit_cost, recipes[i].nre_cost, project.margin, recipes[i].lot_cost));
            this.recipeDict[ connectingID ] = { recipe: recipes[i], quantityBreakDown: quantityBreakDown, exclude_nre: 0, amortize_nre: 0, default_margin: project.margin  };

            quantityBreakDown = [];
          }
        } else {
          project.projectEdit = false;
          project.newProject = false;
          for (let i = 0; i < recipes.length; i++) {

              let connectingID = this.getRecipeDictconnectingID(recipes[i].id, project);

              if (recipematerialsDict.length > 0) {
                if (recipes[i].recipematerials > 0) { // check if there is a material for the recipe
                  let material_id = recipematerialsDict[recipes[i].recipematerials[0].id];
                  recipes[i].material_id = material_id;
                }
              }

              if (recipes[i].id == project.recipe_id) {

                project.defaultRecipe = project.recipe_id;
                project.recipeConnectingID = connectingID;

                console.log('quoteprojectquantities : ');
                console.log(project.quoteprojectquantities);

                for (let j = 0; j < project.quoteprojectquantities.length; j++) {
                  quantityBreakDown.push(this.quoteprojectquantitiesDict[project.quoteprojectquantities[j].id]);
                }


                this.recipeDict[connectingID] = { recipe: recipes[i], quantityBreakDown: quantityBreakDown, exclude_nre: project.exclude_nre, amortize_nre: project.amortize_nre, default_margin: project.margin };
              } else {

                quantityBreakDown.push(this.addQuantityBreakDown(0, 1, recipes[i].unit_cost, recipes[i].nre_cost, project.margin, recipes[i].lot_cost));

                 this.recipeDict[connectingID] = { recipe: recipes[i], quantityBreakDown: quantityBreakDown, exclude_nre: 0, amortize_nre: 0, default_margin: project.margin };
            }
            quantityBreakDown = [];
          }
        }

        project.loadingQuoteprojects = true;
        this.LoadedSelectedProjectsCount++;
        if (this.LoadedSelectedProjectsCount == this.selectedQuotesProjectsCount) {
          this.LoadedSelectedProjectsCount = 0;
          this.selectedQuotesProjectsCount = 0;
          this.showCreateQuoteButton = true;
        }

        // Remove it if project does not have any recipe/defaultRecipe.
        if (!project.defaultRecipe) {
          this.addEditableRecipe(project, project_id, newrecipe);
        }
      },
      error => {
        project.loadingQuoteprojects = true;
        this.LoadedSelectedProjectsCount++;
        if (this.LoadedSelectedProjectsCount == this.selectedQuotesProjectsCount) {
          this.LoadedSelectedProjectsCount = 0;
          this.selectedQuotesProjectsCount = 0;
          this.showCreateQuoteButton = true;
        }
        Materialize.toast('SERVER ISSUE - PLEASE TRY AGAIN', 1500);
        console.log('SERVER ISSUE - PLEASE TRY AGAIN');
      });
  }

  chnagedefaultRecipe(quoteproject: any, index: any) {

    let val = (<HTMLInputElement>document.getElementById('estimateEdit' + index)).value;
    quoteproject.defaultRecipe = Number(val);
    quoteproject.recipeConnectingID =  this.getRecipeDictconnectingID(quoteproject.defaultRecipe, quoteproject); // quoteproject.recipeConnectingReference;

    (<HTMLInputElement>document.getElementById('newquoteprojectExclude_nre' + index)).checked = this.recipeDict[quoteproject.recipeConnectingID].exclude_nre;
    (<HTMLInputElement>document.getElementById('newquoteprojectAmortize_nre' + index)).checked = this.recipeDict[quoteproject.recipeConnectingID].amortize_nre;
  }


  // Add's margin
  addDefaultMargin(parentProject: any, customer: any) {

    if (customer) {
        parentProject.margin = customer.default_margin;
    } else {
        parentProject.margin = this.defaultMargin;
    }
  }

  openmodalNewQuoteWithProjectLocalContent() {

    this.selectedProjects = [];
    this.temproryselectedProjects = [];
    this.parentProject.recipe_id = 0;
    this.parentProject.referenceCountNumber = 1;
    this.parentProject.quoteprojectordertype_id = 1;
    this.parentProject.note = '';
    this.parentProject.quoteprojectstatus_id = 0;
    this.parentProject.recipe_unit_cost = 0;
    this.parentProject.recipe_nre_cost = 0;
    this.parentProject.recipe_lot_cost = 0;
    this.parentProject.defaultRecipe = 0;
    this.parentProject.quantityBreakDown = [];


    // Add Margin
    this.addDefaultMargin(this.parentProject, this.customersDict[this.parentProject.customer_id]);


    let newRecipe = true;
    this.parentProject.loadingQuoteprojects = false;
    this.getRecipe(this.parentProject, this.parentProject.id, newRecipe, 1);
    this.selectedProjects.push(this.parentProject);


    this.modalNewQuoteAction.emit({ action: 'modal', params: ['open'] });

    this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
      (<HTMLInputElement>document.getElementById('quoteSelectedCustomerId')).value = this.parentProject.customer_id;
      (<HTMLInputElement>document.getElementById('quoteSelectedOwner')).value = this.parentProject.assigned_id;
      this.newQuoteSelctedCustomerId = this.parentProject.customer_id;

      if (this.parentProject.customer_id != 0) {
        // Error in db  customer contact must be present . for now we have added  this check .
        (<HTMLInputElement>document.getElementById('quoteSelectedCustomerContactId')).value = this.customercontactDict[this.parentProject.customer_id];
      }
    });

  }

  openmodalNewQuoteWithRecipeLocalContent() {

    this.selectedProjects = [];
    this.temproryselectedProjects = [];
    this.parentProject.recipe_id = 0;
    this.parentProject.referenceCountNumber = 1;
    this.parentProject.quoteprojectordertype_id = 1;
    this.parentProject.note = '';
    this.parentProject.quoteprojectstatus_id = 0;
    this.parentProject.recipe_unit_cost = 0;
    this.parentProject.recipe_nre_cost = 0;
    this.parentProject.recipe_lot_cost = 0;
    this.parentProject.defaultRecipe = 0;
    this.parentProject.quantityBreakDown = [];

    this.addDefaultMargin(this.parentProject, this.customersDict[this.parentProject.customer_id]);

    let newRecipe = true;
    this.parentProject.loadingQuoteprojects = false;

    let connectingID = this.getRecipeDictconnectingID(this.selctedLocalRecipe, this.parentProject);

    this.parentProject.defaultRecipe = this.selctedLocalRecipe;
    this.parentProject.recipeConnectingID = connectingID;
    this.setRecipeData(this.localRecipies, this.parentProject, this.parentProject.id, newRecipe);

    this.selectedProjects.push(this.parentProject);
    this.modalNewQuoteAction.emit({ action: 'modal', params: ['open'] });

    this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
      (<HTMLInputElement>document.getElementById('quoteSelectedCustomerId')).value = this.parentProject.customer_id;
      (<HTMLInputElement>document.getElementById('quoteSelectedOwner')).value = this.parentProject.assigned_id;
      this.newQuoteSelctedCustomerId = this.parentProject.customer_id;

      if (this.parentProject.customer_id != 0) {
        // Error in db  customer contact must be present . for now we have added  this check .
        (<HTMLInputElement>document.getElementById('quoteSelectedCustomerContactId')).value = this.customercontactDict[this.parentProject.customer_id];
      }
    });

  }


  addNewQuoteSubmit() {

    if (this.selectedProjects.length <= 0) {
      Materialize.toast('PLEASE ADD A PROJECT LINE ITEM', 1500);
      console.log('PLEASE ADD A PROJECT LINE ITEM');
      return;
    }

    let due_date = ((<HTMLInputElement>document.getElementById('quoteDueDate')).value);

    if (due_date.length <= 0) {
      Materialize.toast('PLEASE SELECT A QUOTE DUE DATE', 1500);
      console.log('PLEASE SELECT A QUOTE DUE DATE');
      return;
    }

    let quote = {
      customer_id: Number((<HTMLInputElement>document.getElementById('quoteSelectedCustomerId')).value),
      rfq: (<HTMLInputElement>document.getElementById('recipeDescription')).value,
      customercontact_id: Number((<HTMLInputElement>document.getElementById('quoteSelectedCustomerContactId')).value),
      owner_id: Number((<HTMLInputElement>document.getElementById('quoteSelectedOwner')).value),
      due_date: new Date(due_date).toISOString()
    };

    if (quote.customer_id == 0) {
      Materialize.toast('PLEASE SELECT A CUSTOMER', 1500);
      console.log('PLEASE SELECT A CUSTOMER');
      return;
    }

    if (quote.customer_id == 0) {
      Materialize.toast('PLEASE SELECT A CUSTOMER CONTACT', 1500);
      console.log('PLEASE SELECT A CUSTOMER CONTACT');
      return;
    }

    if (quote.owner_id == 0) {
      Materialize.toast('PLEASE SELECT A OWNER', 1500);
      console.log('PLEASE SELECT A OWNER');
      return;
    }


    let quoteprojects: any = [];

    for (let i = 0; i < this.selectedProjects.length; i++) {

      if (this.selectedProjects[i].editmode) {
        Materialize.toast('PLEASE SAVE QUANTITY BREAK DOWN', 1500);
        console.log('PLEASE SAVE QUANTITY BREAK DOWN');
        return;
      }

      let x = document.getElementById('editQuoteproject' + i);
      if (x.style.display === 'none') {
        Materialize.toast('PLEASE SAVE ALL LINE ITEMS', 1500);
        console.log('PLEASE SAVE ALL LINE ITEMS');
        return;
      }
      let quoteprojectquantities: any = [];

      for (let quantityBreakDown of this.recipeDict[this.selectedProjects[i].recipeConnectingID].quantityBreakDown) {
        let quoteprojectquantity = {
          quantity: quantityBreakDown.quantity,
          unit_price: quantityBreakDown.unit_price,
          nre_price: quantityBreakDown.nre_price,
          margin: quantityBreakDown.margin,
          lead_time: quantityBreakDown.lead_time,
        };

        quoteprojectquantities.push(quoteprojectquantity);
      }

      let needby_date: string = '';

      if (this.selectedProjects[i].needby_date) {
      if (this.selectedProjects[i].needby_date.length > 0) {
        needby_date = new Date(this.selectedProjects[i].needby_date).toISOString();
      } else {
        needby_date = null;
      }
    }

      let quoteproject = {
        project_id: this.selectedProjects[i].id,
        recipe_id: this.selectedProjects[i].defaultRecipe,
        quoteprojectordertype_id: this.selectedProjects[i].quoteprojectordertype_id,
        quoteprojectquantities: quoteprojectquantities,
        needby_date: needby_date,
        note: this.selectedProjects[i].note,
        amortize_nre: this.recipeDict[this.selectedProjects[i].recipeConnectingID].amortize_nre,
        exclude_nre: this.recipeDict[this.selectedProjects[i].recipeConnectingID].exclude_nre,
        recipe_unit_cost: this.recipeDict[this.selectedProjects[i].recipeConnectingID].recipe.unit_cost,
        recipe_nre_cost: this.recipeDict[this.selectedProjects[i].recipeConnectingID].recipe.nre_cost,
        recipe_lot_cost: this.recipeDict[this.selectedProjects[i].recipeConnectingID].recipe.lot_cost,
      };
      quoteprojectquantities = [];
      quoteprojects.push(quoteproject);
    }

    this.waiticon = 'fa right fa-spinner fa-pulse';
    this.quoteService.addQuote(quote, quoteprojects)
      .subscribe(
      data => {

        try {
          this.waiticon = '';
          let json = JSON.parse(data);
          if (json == true) {
            Materialize.toast('NEW QUOTE CREATED SUCCESSFULLY', 1500);
            console.log('NEW QUOTE CREATED SUCCESSFULLY');
            this.modalNewQuoteAction.emit({ action: 'modal', params: ['close'] });
            this.newQuotedata = true;
            this.refreshQuote();

          } else {
            console.log('INTERNAL ERROR WHILE CREATING QUOTE: ');
            Materialize.toast('INTERNAL ERROR WHILE CREATING QUOTE.', 1500);
          }
        } catch (e) {
          console.log('INTERNAL ERROR WHILE CREATING QUOTE: ' + e);
          Materialize.toast('INTERNAL ERROR WHILE CREATING QUOTE.', 1500);
        }
      },
      error => {
        this.waiticon = '';
        console.log('INTERNAL ERROR WHILE CREATING QUOTE: ' + error);
        Materialize.toast('INTERNAL ERROR WHILE CREATING QUOTE.', 1500);
      });

  }


  openmodalNewQuote() {

    this.selectedProjects = [];
    this.temproryselectedProjects = [];

    this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
      (<HTMLInputElement>document.getElementById('quoteSelectedCustomerId')).value = '';
      (<HTMLInputElement>document.getElementById('quoteSelectedOwner')).value = '';

      if (this.parentProject.customer_id != 0) {
        // Error in db  customer contact must be present . for now we have added  this check .
        (<HTMLInputElement>document.getElementById('quoteSelectedCustomerContactId')).value = '';
      }
      (<HTMLInputElement>document.getElementById('recipeDescription')).value = '';
      (<HTMLInputElement>document.getElementById('quoteDueDate')).value = '';
    });

    this.modalNewQuoteAction.emit({ action: 'modal', params: ['open'] });
  }

  editquotecomment() {

    document.getElementById('comments').style.display = 'none';
    document.getElementById('commentsEdit').style.display = 'block';

    (<HTMLInputElement>document.getElementById('commenttextarea')).value = this.selectedQuote.comment_id;

    document.getElementById('quotecommentEdit').style.display = 'none';
    document.getElementById('quotecommentApply').style.display = 'inline-block';
    document.getElementById('quotecommentCancel').style.display = 'inline-block';
  }

  savequotecomment() {
    document.getElementById('comments').style.display = 'block';
    document.getElementById('commentsEdit').style.display = 'none';

    document.getElementById('quotecommentEdit').style.display = 'block';
    document.getElementById('quotecommentApply').style.display = 'none';
    document.getElementById('quotecommentCancel').style.display = 'none';

    console.log('saving quote comment..');
    let comment = (<HTMLInputElement>document.getElementById('commenttextarea')).value;

    this.selectedQuote.comment_id = comment;

    this.quoteService.updateQuoteComment(this.selectedQuote, comment).subscribe(
      data => {
        console.log('quote comment updated');
        this.selectedQuote.comment_id = comment;
      },
      error => {
        console.log('quote comment not updated', error);
      });
  }
  cancelquotecomment() {
    document.getElementById('comments').style.display = 'block';
    document.getElementById('commentsEdit').style.display = 'none';
    document.getElementById('quotecommentEdit').style.display = 'block';
    document.getElementById('quotecommentApply').style.display = 'none';
    document.getElementById('quotecommentCancel').style.display = 'none';
  }
  openmodalAddLineItem() {
    this.modalAddLineItemAction.emit({ action: 'modal', params: ['open'] });
  }
  onDownloadQuote(selectedQuote) {

    this.selectedQuote = selectedQuote;
    let url = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/quotes/' + this.selectedQuote.id + '/' + this.selectedQuote.quote_number_id + '.pdf';
    this.validPDF = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/quotes/' + this.selectedQuote.id + '/' + this.selectedQuote.quote_number_id + '.png';
    window.open(url);
  }

  getQuoteURL(selectedQuote) {
    let url = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/quotes/' + selectedQuote.id + '/' + selectedQuote.quote_number_id + '.pdf';
    return url;
  }

  openmodalEditQuote(selectedQuote: any) {
    this.selectedQuoteId = selectedQuote.id;
    this.selectedQuote = this.quoteDict[this.selectedQuoteId];
    this.selectedProjects = [];
    this.showCreateQuoteButton = false;
    this.LoadedSelectedProjectsCount = 0;
    this.selectedQuotesProjectsCount = this.quoteprojectsDict[this.selectedQuoteId].length;
    for (let i = 0; i < this.quoteprojectsDict[this.selectedQuoteId].length; i++) {

      this.quoteprojectsDict[this.selectedQuoteId][i].quantityBreakDown = [];
      this.quoteprojectsDict[this.selectedQuoteId][i].loadingQuoteprojects = false;
      this.quoteprojectsDict[this.selectedQuoteId][i].referenceCountNumber = 1 + i;

      let newRecipe = false;
      this.quoteprojectsDict[this.selectedQuoteId][i].margin = this.customersDict[selectedQuote.customer_id].default_margin;
      let substringTest = function (str) {
        return;
      };
      let res = this.quoteprojectsDict[this.selectedQuoteId][i].thumbnail.substring(this.quoteprojectsDict[this.selectedQuoteId][i].thumbnail.lastIndexOf('/') + 1).slice(0, 4);

      if (res) {
        this.quoteprojectsDict[this.selectedQuoteId][i].temp_thumb = '/assets/images/temppdffix/' + res + '.png';
      }
      this.getRecipe(this.quoteprojectsDict[this.selectedQuoteId][i], this.quoteprojectsDict[this.selectedQuoteId][i].project_id, newRecipe, i);
    }
    this.selectedProjects = this.quoteprojectsDict[this.selectedQuoteId];


    this.validPDF = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/quotes/' + this.selectedQuote.id + '/' + this.selectedQuote.quote_number_id + '.pdf';
    let pdfurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/quotes/' + this.selectedQuote.id + '/' + this.selectedQuote.quote_number_id + '.pdf';
    this.modalEditQuoteAction.emit({ action: 'modal', params: ['open'] });

    this.showPDF(pdfurl);
    let self = this;
    // Pär - commented this for now because it's overwriting all modal style definitions
    /* if (!this.newQuotedata) {
      jQuery('ul.tabs').tabs();
      jQuery('ul.tabs').tabs('select_tab', 'quoteLineItems');
      jQuery('lineitemstab').addClass('active');
      this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
          jQuery('.modal').modal({
            ready: function (modal, trigger) { // Callback for Modal open. Modal and trigger parameters available.
              self.addIndicatorStyle();
            }
        });
      });
    } else if (this.newQuotedata) {
      this.modalEditQuoteAction.emit({ action: 'modal', params: ['open'] });
      jQuery('ul.tabs').tabs();
      jQuery('ul.tabs').tabs('select_tab', 'quoteInfo');
      jQuery('lineQuoteInfotab').addClass('active');
      this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
        jQuery(document).ready(function () {
          jQuery('.modal').modal({
            ready: function (modal, trigger) { // Callback for Modal open. Modal and trigger parameters available.
              $('#modalEditQuote').find('.indicator').attr('style', 'right: 33%; left: 33%;');
              this.newQuotedata = false;
            }
          });
        });
      });
    } */
  }


  // Pär - commented this for now because it's overwriting all modal style definitions
  /*
  addIndicatorStyle() {
    $('#modalEditQuote').find('.indicator').attr('style', 'right: 66%; left: 0px;');
  }  */


  showPDF(pdf_url) {
    const pdf_url_v = pdf_url + '?v=' + Math.random();
    $('#pdf-loader').show();
    this.loadingpdfPreview = true;
    console.log('loading pdf shown 1');
    this.canvasdiv = document.getElementById('pdf-canvas');
    this.canvasContext = (<HTMLCanvasElement>this.canvasdiv).getContext('2d');
    this.canvasContext.clearRect(0, 0, (<HTMLCanvasElement>this.canvasdiv).width, (<HTMLCanvasElement>this.canvasdiv).height);
    let self = this;

    console.log('URL:', pdf_url_v);

    PDFJS.getDocument({ url: pdf_url_v }).then(function (pdf_doc) {
      console.log('loading pdf shown 2');
      self.showPage(1, pdf_doc);
    }).catch(function (error) {
      console.error('ERROR:', error);
      setTimeout(() => {
        self.updatePDFQuoteSubmit();
      }, 2000);
    });
  }


  showPage(page_no, pdf_doc) {
    let __CURRENT_PAGE = page_no;
    $('#page-loader').show();
    let self = this;
    pdf_doc.getPage(page_no).then(function (page) {

      let scale_required: number = 400 / page.getViewport(1).width;
      console.log('loading pdf shown 3');

      // Get viewport of the page at required scale
      let viewport = page.getViewport(scale_required);

      // Set canvas height
      (<HTMLCanvasElement>self.canvasdiv).height = viewport.height;

      let renderContext = {
        canvasContext: self.canvasContext,
        viewport: viewport
      };

      // Render the page contents in the canvas
      page.render(renderContext).then(function () {
        console.log('loading pdf hide 4');
        $('pdf-canvas').show();
        $('#page-loader').hide();
        self.loadingpdfPreview = false;
      });
    });
  }

  OpenPDFView() {
    localStorage.setItem('saved_pdfurl', this.validPDF);
    window.open('/#/pdfviewer');
  }

  onErrorThumb() {

  }

  editSearchFieldrow(control) {

    document.getElementById(control).style.display = 'none';
    document.getElementById(control + 'Edit').style.display = 'block';

    if (control != this.currentControl) {
      if (this.currentControl) {
        this.saveSearchFieldRow(this.currentControl);
        this.filteredMaterialList = [];
        this.filteredCustomerList = [];
        this.filteredOwnerList = [];
      }
    }
    document.getElementById(control + 'Edit').focus();
    this.currentControl = control;
  }

  saveSearchFieldRow(control) {
    console.log(control);

    document.getElementById(control).style.display = 'block';
    document.getElementById(control + 'Edit').style.display = 'none';

    if (control == 'ProjectNameSearch') {
      this.projectNameSearch = (<HTMLInputElement>document.getElementById('ProjectNameSearchEdit')).value;
    }
    if (control == 'PartNumberSearch') {
      this.partNumberSearch = (<HTMLInputElement>document.getElementById('PartNumberSearchEdit')).value;
    }
    if (control == 'RevisionSearch') {
      this.revisionSearch = (<HTMLInputElement>document.getElementById('RevisionSearchEdit')).value;
    }
    if (control == 'MaterialSearch') {
      let materialSearch: number = Number((<HTMLInputElement>document.getElementById('MaterialSearchEdit')).value);

      for (let i = 0; i < this.materialArray.length; i++) {

        if (this.materialArray[i].id == materialSearch) {
          this.materialselectSearchString = this.materialArray[i].name;
        }
      }
    }

    if (control == 'CustomerSelect') {
      this.customerSearch = (<HTMLInputElement>document.getElementById('CustomerSelectEdit')).value;

      for (let i = 0; i < this.customers.length; i++) {

        if (this.customers[i].id == this.customerSearch) {
          this.customerselectSearchString = this.customers[i].name;
        }
      }
    }

    if (control == 'OwnerSearch') {
      let ownerSearch = Number((<HTMLInputElement>document.getElementById('OwnerSearchEdit')).value);

      for (let i = 0; i < this.owners.length; i++) {

        if (this.owners[i].id == ownerSearch) {
          this.ownerSelectSearchString = this.owners[i].email;
        }
      }
    }
    if (control == 'StatusSearch') {
      let statusSearch = Number((<HTMLInputElement>document.getElementById('StatusSearchEdit')).value);
      this.statusSelectSearchString = this.statusArray[statusSearch];
    }

    if (control == 'DateRange') {
      let dateRangeSearch = Number((<HTMLInputElement>document.getElementById('DateRangeEdit')).value);
      this.dateRangeString = this.dateRangeArray[dateRangeSearch];
    }

    if (control == 'date') {
      this.createdDateSearch = (<HTMLInputElement>document.getElementById('dateEdit')).value;
      // this.createdDateSearch = this.DateRangeArray[this.dateRangeSearch]
    }
  }

  onMouseoverADVSearch(control) {
    document.getElementById(control).style.display = 'none';
    document.getElementById(control + 'Edit').style.display = 'block';

    if (control != this.currentControl) {
      if (this.currentControl) {
        this.saveSearchFieldRow(this.currentControl);
        this.filteredMaterialList = [];
        this.filteredCustomerList = [];
        this.filteredOwnerList = [];
      }
    }
    this.currentControl = control;
  }

  onMaterialChange(value) {
    console.log('material value', value);
    this.materialselect = value;
    this.materialselectSearch = Number(value);
    this.materialselectSearchString = value;
  }

  onOwnerChange(value) {
    console.log('owner value', value);
    this.ownerselect = value;
    this.ownerselectSearch = Number(value);
    this.ownerSelectSearchString = value;
  }

  onCustomerChange(value) {
    console.log('customer value', value);
    this.customerselect = value;
    this.customerselectSearch = Number(value);
    this.customerselectSearchString = value;
  }

  onCustomerQInfoChange(value) {
    console.log('customer value', value);
    this.customerQinfo_id = value;
  }

  onCustomercontactQInfoChange(value) {
    console.log('customer contact value', value);
    this.customercontactQinfo_id = value;
  }

  onShipviaQInfoChange(value) {
    console.log('Ship via value', value);
    this.shipviaQinfo_id = value;
  }

  onQuotetermQInfoChange(value) {
    console.log('quote term value', value);
    this.quoteTermQinfo_id = value;
  }

  onStatusChange(value) {
    console.log('Status value', value);
    this.statusselect = value;
    this.statusselectSearch = Number(value);
    this.statusSelectSearchString = value;
  }

  onCreatedWithinDateChange(value) {
    console.log('Status value', value);

    switch (value) {
      case 1: {
        this.numberofDaysSearch = Number(7);
        break;
      }
      case 2: {
        this.numberofDaysSearch = Number(14);
        break;
      }
      case 3: {
        this.numberofDaysSearch = Number(30);
        break;
      }
      case 4: {
        this.numberofDaysSearch = Number(60);
        break;
      }
      case 5: {
        this.numberofDaysSearch = Number(183);
        break;
      }
      case 6: {
        this.numberofDaysSearch = Number(365);
        break;
      }
      default: {
        this.numberofDaysSearch = Number(7);
      }
    }
  }

  // placeholder - remove once relevant functions are defined
  dummyClick() {
    console.log('Nothing to See here');
  }

  // return the string "MMddyy"
  formatDate(d) {

    return this.datePipe.transform(d, this.dateFormat);
  }

  editRow(quote: any) {

    (<HTMLInputElement>document.getElementById('StatusEdit' + quote.id)).value = quote.quotestatus_id;
    (<HTMLInputElement>document.getElementById('CustomerEdit' + quote.id)).value = quote.customer_id;
    (<HTMLInputElement>document.getElementById('OwnerEdit' + quote.id)).value = quote.owner_id;
    (<HTMLInputElement>document.getElementById('ContactEdit' + quote.id)).value = quote.customercontact_id;

    if (quote.due_date != '0000-00-00 00:00:00') {
      let due_date = new Date(quote.due_date);

      (<HTMLInputElement>document.getElementById('QuoteDueDateEdit' + quote.id)).value = this.formatDate(due_date);
    }

    this.startRowEditMode(quote.id);
  }

  saveRow(quote: any) {

    this.updateQuoteSubmit(quote);
  }


  editQuotRow(quoteproject: any) {


    (<HTMLInputElement>document.getElementById('StatusEdit' + quoteproject.id)).value = quoteproject.quotestatus_id;
    (<HTMLInputElement>document.getElementById('CustomerEdit' + quoteproject.id)).value = quoteproject.customer_id;
    (<HTMLInputElement>document.getElementById('OwnerEdit' + quoteproject.id)).value = quoteproject.owner_id;
    (<HTMLInputElement>document.getElementById('ContactEdit' + quoteproject.id)).value = quoteproject.customercontact_id;

  }

  editNewQuoteRow(quoteproject: any, index: number) {

    this.newQuoteButtonStatus = true;
    quoteproject.oldDefaultRecipe = quoteproject.defaultRecipe;
    quoteproject.oldneedby_date = quoteproject.needby_date;
    (<HTMLInputElement>document.getElementById('newquoteDueDateEdit' + index)).value = quoteproject.needby_date;
    (<HTMLInputElement>document.getElementById('orderTypeEdit' + index)).value = quoteproject.quoteprojectordertype_id;
    (<HTMLInputElement>document.getElementById('quoteNoteEdit' + index)).value = quoteproject.note;
    (<HTMLInputElement>document.getElementById('estimateEdit' + index)).value = quoteproject.defaultRecipe;


    if (quoteproject.recipeConnectingID < 0) {
      (<HTMLInputElement>document.getElementById('unit_costEdit' + index)).value = this.recipeDict[quoteproject.recipeConnectingID].recipe.unit_cost;
      (<HTMLInputElement>document.getElementById('nre_costEdit' + index)).value = this.recipeDict[quoteproject.recipeConnectingID].recipe.nre_cost;
    }

    this.startNewQuoteRowEditMode(quoteproject.recipeConnectingID, index);
  }

  recalculateRecipeQuantityBreakDown(recipeId) {

    let quantityBreakdown = this.recipeDict[recipeId].quantityBreakDown;
    this.recipeDict[recipeId].quantityBreakDown = [];
    for (let i = 0; i < quantityBreakdown.length; i++) {
      let quantity = quantityBreakdown.quantity;
      if (this.recipeDict[recipeId].amortize_nre) {
        this.recipeDict[recipeId].quantityBreakDown.push(this.manageAccoudingtoAmortizeNRE(this.addQuantityBreakDown(quantityBreakdown[i].index, quantityBreakdown[i].quantity, this.recipeDict[recipeId].recipe.unit_cost, this.recipeDict[recipeId].recipe.nre_cost, this.recipeDict[recipeId].default_margin, this.recipeDict[recipeId].recipe.lot_cost)));
      } else {

        if (this.recipeDict[recipeId].exclude_nre) {
          this.recipeDict[recipeId].quantityBreakDown.push(this.addQuantityBreakDown(quantityBreakdown[i].index, quantityBreakdown[i].quantity, this.recipeDict[recipeId].recipe.unit_cost, 0, this.recipeDict[recipeId].default_margin, this.recipeDict[recipeId].recipe.lot_cost));
        } else {
          this.recipeDict[recipeId].quantityBreakDown.push(this.addQuantityBreakDown(quantityBreakdown[i].index, quantityBreakdown[i].quantity, this.recipeDict[recipeId].recipe.unit_cost, this.recipeDict[recipeId].recipe.nre_cost, this.recipeDict[recipeId].default_margin, this.recipeDict[recipeId].recipe.lot_cost));
        }
      }
    }
  }

  saveNewQuoteRow(quoteproject: any, index: number) {

    if (quoteproject.recipeConnectingID < 0) {
      let unit_cost = (<HTMLInputElement>document.getElementById('unit_costEdit' + index)).value;
      let nre_cost = (<HTMLInputElement>document.getElementById('nre_costEdit' + index)).value;
      if (!this.isPositiveNumber(unit_cost)) {
        Materialize.toast('PLEASE ENTER A POSITIVE NUMBER FOR UNIT COST.', 2000);
        (<HTMLInputElement>document.getElementById('unit_costEdit' + index)).value = '';
        return;
      }
      if (!this.isPositiveNumber(nre_cost)) {
        Materialize.toast('PLEASE ENTER A POSITIVE NUMBER FOR NRE COST.', 2000);
        (<HTMLInputElement>document.getElementById('nre_costEdit' + index)).value = '';
        return;
      }
      this.recipeDict[quoteproject.recipeConnectingID].recipe.nre_cost = Number(nre_cost);
      this.recipeDict[quoteproject.recipeConnectingID].recipe.unit_cost = Number(unit_cost);
      this.recalculateRecipeQuantityBreakDown(quoteproject.recipeConnectingID);
    }

    let needby_date = (<HTMLInputElement>document.getElementById('newquoteDueDateEdit' + index)).value;
    if (needby_date) {
      quoteproject.needby_date = needby_date;
    }

    quoteproject.recipe_id = (<HTMLInputElement>document.getElementById('estimateEdit' + index)).value;
    quoteproject.quoteprojectordertype_id = (<HTMLInputElement>document.getElementById('orderTypeEdit' + index)).value;
    quoteproject.note = (<HTMLInputElement>document.getElementById('quoteNoteEdit' + index)).value;

    this.endNewQuoteRowEdit(quoteproject.recipeConnectingID, index);
    this.newQuoteButtonStatus = false;
  }

  cancelEditNewQuoteRow(quoteproject: any, index: number) {

    if (quoteproject.oldneedby_date) {
      quoteproject.needby_date = quoteproject.oldneedby_date;
    } else {
      if (!quoteproject.oldneedby_date) {
        quoteproject.needby_date = '';
      }
    }

    if (quoteproject.oldDefaultRecipe) {
      quoteproject.defaultRecipe = quoteproject.oldDefaultRecipe;
    }
    this.endNewQuoteRowEdit(quoteproject.defaultRecipe, index);
    this.newQuoteButtonStatus = false;
  }

  startNewQuoteRowEditMode(quoteprojectId: number, index: number) {

    document.getElementById('estimate' + index).style.display = 'none';
    document.getElementById('estimateEdit' + index).style.display = 'block';

    document.getElementById('orderType' + index).style.display = 'none';
    document.getElementById('orderTypeEdit' + index).style.display = 'block';

    document.getElementById('newquoteDueDate' + index).style.display = 'none';
    document.getElementById('newquoteDueDateEdit' + index).style.display = 'block';

    document.getElementById('quoteNote' + index).style.display = 'none';
    document.getElementById('quoteNoteEdit' + index).style.display = 'block';

    if (quoteprojectId < 0) {
      document.getElementById('unit_cost' + index).style.display = 'none';
      document.getElementById('unit_costEdit' + index).style.display = 'block';

      document.getElementById('nre_cost' + index).style.display = 'none';
      document.getElementById('nre_costEdit' + index).style.display = 'block';
    }

    document.getElementById('editQuoteproject' + index).style.display = 'none';
    document.getElementById('removeQuoteproject' + index).style.display = 'none';
    document.getElementById('saveQuoteproject' + index).style.display = 'inline-block';
    document.getElementById('cancelQuoteproject' + index).style.display = 'inline-block';

    document.getElementById('quantityBreakDownEdit' + index).style.display = 'none';
  }

  endNewQuoteRowEdit(quoteprojectId: number, index: number) {

    document.getElementById('estimate' + index).style.display = 'block';
    document.getElementById('estimateEdit' + index).style.display = 'none';

    document.getElementById('orderType' + index).style.display = 'block';
    document.getElementById('orderTypeEdit' + index).style.display = 'none';

    document.getElementById('newquoteDueDate' + index).style.display = 'block';
    document.getElementById('newquoteDueDateEdit' + index).style.display = 'none';

    document.getElementById('quoteNote' + index).style.display = 'block';
    document.getElementById('quoteNoteEdit' + index).style.display = 'none';

    if (quoteprojectId < 0) {

      document.getElementById('unit_cost' + index).style.display = 'block';
      document.getElementById('unit_costEdit' + index).style.display = 'none';

      document.getElementById('nre_cost' + index).style.display = 'block';
      document.getElementById('nre_costEdit' + index).style.display = 'none';
    }

    document.getElementById('editQuoteproject' + index).style.display = 'inline-block';
    document.getElementById('removeQuoteproject' + index).style.display = 'inline-block';
    document.getElementById('saveQuoteproject' + index).style.display = 'none';
    document.getElementById('cancelQuoteproject' + index).style.display = 'none';

    document.getElementById('quantityBreakDownEdit' + index).style.display = 'block';
  }

  quantityBreakDownHeaderClicked(quoteprojectId: number, index: number) {

    console.log('quantity BreakDown Header Clicked');
    console.log(' Index : ', quoteprojectId);

    if (document.getElementById(index + '_quantityBreak_collapsible_body').className != 'active') {

      document.getElementById('quantityBreakDownArrowexpand' + index).style.display = 'block';
      document.getElementById('quantityBreakDownAddAarrowright' + index).style.display = 'none';
      document.getElementById('quoteprojectquantityEdit' + index).style.display = 'none';

    } else {
      document.getElementById('quantityBreakDownArrowexpand' + index).style.display = 'none';
      document.getElementById('quantityBreakDownAddAarrowright' + index).style.display = 'block';
      document.getElementById('quoteprojectquantityEdit' + index).style.display = 'n';
    }
  }


  SaveRowChangesInUI(updatedQuote, quote: any) {

    quote.rfq = updatedQuote.rfq;
    quote.customer_id = updatedQuote.customer_id;
    quote.customercontact_id = updatedQuote.customercontact_id;
    quote.due_date = updatedQuote.due_date;
    quote.owner_id = updatedQuote.owner_id;
    quote.quotestatus_id = updatedQuote.quotestatus_id;

    this.endRowEditMode(quote.id);
  }

  updateQuoteSubmit(quote: any) {

    document.getElementById('EditCancel' + quote.id).style.display = 'none';
    document.getElementById('EditApply' + quote.id).style.display = 'none';
    document.getElementById('quoteApplyloading' + quote.id).style.display = 'block';


    let due_date = (<HTMLInputElement>document.getElementById('QuoteDueDateEdit' + quote.id)).value;
    due_date = new Date(Date.parse(due_date)).toISOString();


    let updatedquote = {
      id: quote.id,
      rfq: ((<HTMLInputElement>document.getElementById('RFQEdit' + quote.id)).value),
      customer_id: Number((<HTMLInputElement>document.getElementById('CustomerEdit' + quote.id)).value),
      customercontact_id: Number((<HTMLInputElement>document.getElementById('ContactEdit' + quote.id)).value),
      due_date: due_date,
      owner_id: Number(((<HTMLInputElement>document.getElementById('OwnerEdit' + quote.id)).value)),
      quotestatus_id: Number(((<HTMLInputElement>document.getElementById('StatusEdit' + quote.id)).value)),
    };

    this.quoteService.updateQuote(updatedquote).subscribe(
      data => {
        try {
          let json = JSON.parse(data);
          if (json == true) {
            Materialize.toast('QUOTE ' + quote.quote_number_id + ' UPDATED SUCCESSFULLY', 1500);
            console.log('QUOTE UPDATED SUCCESSFULLY.');
            this.SaveRowChangesInUI(updatedquote, quote);
          } else {
            console.log('INTERNAL ERROR WHILE UPDATING QUOTE: ');
            Materialize.toast('INTERNAL ERROR WHILE UPDATING QUOTE.', 1500);
          }
        } catch (e) {
          console.log('INTERNAL ERROR WHILE UPDATING QUOTE: ' + e);
          Materialize.toast('INTERNAL ERROR WHILE UPDATING QUOTE.', 1500);
        }
      },
      error => {
        console.log('INTERNAL ERROR WHILE UPDATING QUOTE: ' + error);
        Materialize.toast('INTERNAL ERROR WHILE UPDATING QUOTE.', 1500);
      });

  }

  removeNewQuoteRow(quoteproject: any) {

    let indexOfProject = this.selectedProjects.indexOf(quoteproject);
      console.log('INDEX of PROJECT: ' + indexOfProject);
    if (indexOfProject != -1) {
      this.selectedProjects.splice(indexOfProject, 1);
    }
    // set quote create button to inactive if no line items
    if (indexOfProject == 0) {
      this.newQuoteButtonStatus = true;
    }
  }

  cancelEditRow(quoteId: number) {
    this.endRowEditMode(quoteId);
  }

  startRowEditMode(quoteId: number) {

    document.getElementById('RFQ' + quoteId).style.display = 'none';
    document.getElementById('RFQEdit' + quoteId).style.display = 'block';

    document.getElementById('Customer' + quoteId).style.display = 'none';
    document.getElementById('CustomerEdit' + quoteId).style.display = 'block';

    document.getElementById('Contact' + quoteId).style.display = 'none';
    document.getElementById('ContactEdit' + quoteId).style.display = 'block';

    document.getElementById('QuoteDueDate' + quoteId).style.display = 'none';
    document.getElementById('QuoteDueDateEdit' + quoteId).style.display = 'block';

    document.getElementById('Owner' + quoteId).style.display = 'none';
    document.getElementById('OwnerEdit' + quoteId).style.display = 'block';

    document.getElementById('Status' + quoteId).style.display = 'none';
    document.getElementById('StatusEdit' + quoteId).style.display = 'block';

    document.getElementById('WinRate' + quoteId).style.display = 'none';
    document.getElementById('WinRateEdit' + quoteId).style.display = 'block';

    document.getElementById('Edit' + quoteId).style.display = 'none';
    document.getElementById('QuoteActions' + quoteId).style.display = 'none';

    document.getElementById('EditApply' + quoteId).style.display = 'block';
    document.getElementById('EditCancel' + quoteId).style.display = 'block';

  }


  endRowEditMode(quoteId: number) {

    document.getElementById('RFQ' + quoteId).style.display = 'block';
    document.getElementById('RFQEdit' + quoteId).style.display = 'none';

    document.getElementById('Customer' + quoteId).style.display = 'block';
    document.getElementById('CustomerEdit' + quoteId).style.display = 'none';

    document.getElementById('Contact' + quoteId).style.display = 'block';
    document.getElementById('ContactEdit' + quoteId).style.display = 'none';

    document.getElementById('QuoteDueDate' + quoteId).style.display = 'block';
    document.getElementById('QuoteDueDateEdit' + quoteId).style.display = 'none';

    document.getElementById('Owner' + quoteId).style.display = 'block';
    document.getElementById('OwnerEdit' + quoteId).style.display = 'none';

    document.getElementById('Status' + quoteId).style.display = 'block';
    document.getElementById('StatusEdit' + quoteId).style.display = 'none';

    document.getElementById('WinRate' + quoteId).style.display = 'block';
    document.getElementById('WinRateEdit' + quoteId).style.display = 'none';

    document.getElementById('Edit' + quoteId).style.display = 'block';
    document.getElementById('QuoteActions' + quoteId).style.display = 'block';

    document.getElementById('EditApply' + quoteId).style.display = 'none';
    document.getElementById('EditCancel' + quoteId).style.display = 'none';
    document.getElementById('quoteApplyloading' + quoteId).style.display = 'none';

  }

  createAdvancedSearchJSONBody() {

    if (this.createdDateSearch == undefined || this.numberofDaysSearch == undefined || this.createdDateSearch == '') {
      this.numberofDaysSearch = undefined;
      this.createdDateSearch == undefined;
    }

    let advancedSearchJSONbody = {};

    if (this.projectNameSearch) {
      advancedSearchJSONbody['name'] = this.projectNameSearch;
    }

    if (this.partNumberSearch) {
      advancedSearchJSONbody['number'] = this.partNumberSearch;
    }

    if (this.revisionSearch) {
      advancedSearchJSONbody['revision'] = this.revisionSearch;
    }

    if (this.materialselectSearch) {
      advancedSearchJSONbody['material'] = this.materialselectSearch;
    }

    if (this.ownerselectSearch) {
      advancedSearchJSONbody['owner'] = this.ownerselectSearch;
    }

    if (this.statusselectSearch) {
      advancedSearchJSONbody['status'] = this.statusselectSearch;
    }
    if (this.createdDateSearch) {
      advancedSearchJSONbody['createddate'] = this.createdDateSearch;
    }
    if (this.numberofDaysSearch) {
      advancedSearchJSONbody['createddays'] = this.numberofDaysSearch;
    }
    if (this.customerselectSearch) {
      advancedSearchJSONbody['customer'] = this.customerselectSearch;
    }
    advancedSearchJSONbody['advancedSearch'] = 1;

    console.log('serching for :' + advancedSearchJSONbody);

    this.advancedSearchJSONbody = advancedSearchJSONbody;
  }

  createAdvancedSearchRequest() {

    this.createAdvancedSearchJSONBody();
    this.projects = [];
    this.chipArray = [];
    this.updateChip();
    this.advancedSearchProject(this.advancedSearchJSONbody);

  }

  serarchDefault() {

    let customerId = Number((<HTMLInputElement>document.getElementById('quoteSelectedCustomerId')).value);
    let ownerId = Number((<HTMLInputElement>document.getElementById('quoteSelectedOwner')).value);

    this.customerselectSearchString;

    this.onOwnerChange(ownerId);
    this.onCustomerChange(customerId);
    this.ownerSelectSearchString = this.ownerDict[ownerId];
    this.customerselectSearchString = this.customerDict[customerId];

    let advancedSearchmodelFlag: boolean = false;
    this.advancedSearchSubmit(advancedSearchmodelFlag);

    this.modalAddLineItemAction.emit({ action: 'modal', params: ['open'] });
  }

  advancedSearchSubmit(advancedSearchmodelFlag) {

    console.log('submited advancedSearch');

    if (this.currentControl) {
      this.saveSearchFieldRow(this.currentControl);
      this.filteredMaterialList = [];
      this.filteredCustomerList = [];
      this.filteredOwnerList = [];
    }
    this.createAdvancedSearchRequest();

    if (advancedSearchmodelFlag) {
      this.modalAdvancedSearchProjectsAction.emit({ action: 'modal', params: ['close'] });
    }
  }

  advancedSearchProject(searchString) {

    this.loadingprojects = true;
    this.projects = [];
    console.log('advancedSearchProject : ' + searchString);
    this.searchTerms = searchString;
    this.emptySearchProjects = false;
    this.noProjects = false;

    this.config = {
      itemsPerPage: 25,
      currentPage: 1,
      totalItems: 1
    };

    this.advancedSearchProjecCall();
  }

  advancedSearchProjecCall() {

    this.projectforceUpdate = this.projectDataService.getForceUpdateBool();

        this.projectsService.getProjects(this.projectforceUpdate,
          this.config.currentPage,
          this.config.itemsPerPage,
          globals.ProjectType.PROJECT,
          this.searchTerms)
          .subscribe(
          data => {
            this.waiticon = '';
            console.log('Got projects');
            if (Object.keys(data).length === 0) {
              this.loadingprojects = false;
            } else {

              let projectdata = JSON.parse(data);

              this.config.currentPage = projectdata.pagenum;
              this.config.totalItems = projectdata.count;

              if (!projectdata.projects.length) {
                this.emptySearchProjects = true;
                this.waiticon = '';
                this.loadingprojects = false;
              } else {
                this.emptySearchProjects = false;
                this.refreshProjects(data);
              }
              this.projectDataService.setForceUpdateBool(true);

            }
          },
          error => {
            this.waiticon = '';
            console.error('getProjects() error:', error);
            this.loadingprojects = false;
          });

  }
  updateChip() {

    if (this.projectNameSearch) {
      this.chipArray.push({ element: 'Project Name', value: 0, name: this.projectNameSearch });
    }
    if (this.partNumberSearch) {
      this.chipArray.push({ element: 'Part Number', value: 0, name: this.partNumberSearch });
    }
    if (this.revisionSearch) {
      this.chipArray.push({ element: 'Revision', value: 0, name: this.revisionSearch });
    }
    if (this.materialselectSearch) {
      this.chipArray.push({ element: 'Material', value: this.materialselectSearch, name: this.materialselectSearchString });
    }
    if (this.ownerselectSearch) {
      this.chipArray.push({ element: 'Owner', value: this.ownerselectSearch, name: this.ownerSelectSearchString });
    }
    if (this.statusselectSearch) {
      this.chipArray.push({ element: 'Status', value: this.statusselectSearch, name: this.statusSelectSearchString });
    }
    if (this.createdDateSearch && this.numberofDaysSearch) {
      let createdWityhin = this.dateRangeString + ' of ' + this.createdDateSearch;
      this.chipArray.push({ element: 'Created within', value: this.numberofDaysSearch, name: createdWityhin });
    }

    if (this.customerselectSearch) {
      this.chipArray.push({ element: 'Customer', value: this.customerselectSearch, name: this.customerselectSearchString });
    }
  }

  refreshProjects(data) {

    let projectdata = JSON.parse(data);
    console.log('refreshProjects');
    console.log(projectdata);

    let isProcessing = false;

    // Populate the thumbnail URLs
    for (let key in projectdata.projects) {
      // Determine the status of the model file to show
      if (projectdata.projects.hasOwnProperty(key)) {
        if (projectdata.projects[key].upload_status == 1) {
          isProcessing = true;
        }

        // Get the filename extension
        projectdata.projects[key].extension = projectdata.projects[key].filename.split('.').pop();

        // Get the filename without the extension
        let filenamenoext = projectdata.projects[key].filename.replace(/\.[^/.]+$/, '');
        if (!filenamenoext) {
          filenamenoext = ' ';
        }
        filenamenoext = filenamenoext.replace(/[+]/g, '%2B');

        if (projectdata.projects[key].material_id == null || projectdata.projects[key].material_id == 'undefined') {
          projectdata.projects[key].material_id = 0;
        }

        projectdata.projects[key].status_id = 0;
        projectdata.projects[key].filenamenoext = filenamenoext;

        let modeltype = this.utilsService.determineModelType(projectdata.projects[key].filename);

        if (projectdata.projects[key].modeltype_id == 0 && modeltype != 0) {
          projectdata.projects[key].modeltype_id = modeltype;
        }

        if (modeltype != 0) {
          projectdata.projects[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + projectdata.projects[key].id + '/' + filenamenoext + '_320x240.png';
        } else {
          let ext = projectdata.projects[key].extension.toLowerCase();
          console.log('EXTENSION:', ext);
          projectdata.projects[key].thumbnail = this.getFileTypeService.returnFileTypeExtensionURL(ext);
        }

        let val = projectdata.projects[key];
      }

      // Determine the Part Type to show
       projectdata.projects[key].cardparttype = this.utilsService.getModelName(projectdata.projects[key].modeltype_id);

         this.projects.push(projectdata.projects[key]);
    }

    this.loadingprojects = false;
  }

  editAdvancedSearchProjects() {

    this.isEditAdvancedSearch = true;
    this.projectNameSearch = undefined;
    this.partNumberSearch = undefined;
    this.revisionSearch = undefined;
    this.materialselectSearchString = undefined;
    this.customerselectSearchString = undefined;
    this.ownerSelectSearchString = undefined;
    this.statusSelectSearchString = undefined;
    this.dateRangeString = undefined;
    this.createdDateSearch = '1 week';

    for (let i = 0; i < this.chipArray.length; i++) {

      let chip = this.chipArray[i];

      switch (chip.element) {
        case 'Project Name':
          this.projectNameSearch = chip.name;
          break;
        case 'Part Number':
          this.partNumberSearch = chip.name;
          break;
        case 'Revision':
          this.revisionSearch = chip.name;
          break;
        case 'Material':
          this.materialselectSearchString = chip.name;
          (<HTMLInputElement>document.getElementById('MaterialSearchEdit')).value = chip.value;
          break;
        case 'Customer':
          this.customerselectSearchString = chip.name;
          (<HTMLInputElement>document.getElementById('CustomerSelectEdit')).value = chip.value;
          break;
        case 'Owner':
          this.ownerSelectSearchString = chip.name;
          (<HTMLInputElement>document.getElementById('OwnerSearchEdit')).value = chip.value;
          break;
        case 'Status':
          this.statusSelectSearchString = chip.name;
          break;
        case 'Created within':
          let parts = chip.name.split(' of ');
          this.dateRangeString = parts[0];
          this.createdDateSearch = parts[1];
          break;
        default:
          break;
      }
    }

    this.modalAdvancedSearchProjectsAction.emit({ action: 'modal', params: ['open'] });
  }

  openModalAdvancedSearchProjects() {
    this.isEditAdvancedSearch = false;

    document.getElementById('advancedSearchSubmitButton').focus();

    this.projectNameSearch = undefined;
    this.partNumberSearch = undefined;
    this.revisionSearch = undefined;

    (<HTMLInputElement>document.getElementById('ProjectNameSearchEdit')).value = '';
    (<HTMLInputElement>document.getElementById('PartNumberSearchEdit')).value = '';
    (<HTMLInputElement>document.getElementById('RevisionSearchEdit')).value = '';

    this.filteredMaterialList = [];
    this.filteredCustomerList = [];
    this.filteredOwnerList = [];

    this.materialselectSearchString = undefined;
    this.customerselectSearchString = undefined;
    this.dateRangeString = undefined;
    this.createdDateSearch = '1 week';
    this.statusSelectSearchString = undefined;
    this.ownerSelectSearchString = undefined;

    (<HTMLInputElement>document.getElementById('MaterialSearchEdit')).value = '';
    (<HTMLInputElement>document.getElementById('CustomerSelectEdit')).value = '';
    (<HTMLInputElement>document.getElementById('OwnerSearchEdit')).value = '';
    (<HTMLInputElement>document.getElementById('StatusSearchEdit')).value = '';
    (<HTMLInputElement>document.getElementById('DateRangeEdit')).value = '';
    (<HTMLInputElement>document.getElementById('dateEdit')).value = '';
    (<HTMLInputElement>document.getElementById('date')).value = '';

    document.getElementById('ProjectNameSearch').style.display = 'none';
    document.getElementById('ProjectNameSearch').style.display = 'block';
    document.getElementById('ProjectNameSearch').focus();


    this.customerSearch = '';

    this.materialselectSearch = undefined;
    this.ownerselectSearch = undefined;
    this.customerselectSearch = undefined;
    this.statusselectSearch = undefined;
    this.numberofDaysSearch = undefined;

    console.log('openModalAdvancedSearchProjects');
    this.modalAdvancedSearchProjectsAction.emit({ action: 'modal', params: ['open'] });
  }

  openAddLineItemModal(quoteMode: number) {
    let customerId = '';
    let ownerId = '';
    let advancedSearchmodelFlag: boolean = false;
    this.advancedSearchSubmit(advancedSearchmodelFlag);

    if (quoteMode) {
      this.quoteeditMode = true;
    } else {
      this.quoteeditMode = false;
    }
    this.modalAddLineItemAction.emit({ action: 'modal', params: ['open'] });
  }

  addToSelectedProject(data: string) {
    let jdata = JSON.parse(data);
    let index = jdata.index;
    let project = jdata.project;

    let indexOfProject = this.temproryselectedProjects.findIndex(o => o.id === project.id);

    if (indexOfProject == -1) {
      this.temproryselectedProjects.push(project);
    } else {
      this.temproryselectedProjects.splice(indexOfProject, 1);
    }
  }

  addCustomerAndOwner(project: any) {

    let quoteSelectedCustomerId = (<HTMLInputElement>document.getElementById('quoteSelectedCustomerId')).value;
    let quoteSelectedOwner = (<HTMLInputElement>document.getElementById('quoteSelectedOwner')).value;

    // check and add missing data
    if (!quoteSelectedCustomerId) {
      (<HTMLInputElement>document.getElementById('quoteSelectedCustomerId')).value = project.customer_id;
    }
    if (!quoteSelectedOwner) {
      (<HTMLInputElement>document.getElementById('quoteSelectedOwner')).value = project.assigned_id;
    }
  }

  addLineItemSubmit() {

    if (this.temproryselectedProjects.length >= 1) {
      this.addCustomerAndOwner(this.temproryselectedProjects[0]);
    }

    let referenceCountNumber = 0;

    if (this.selectedProjects.length > 0) {
      referenceCountNumber = this.selectedProjects[this.selectedProjects.length - 1].referenceCountNumber;
    }

    for (let i = 0; i < this.temproryselectedProjects.length; i++) {

      this.temproryselectedProjects[i].recipe_id = 0; // Estimate
      // for recipeDict ref
      this.temproryselectedProjects[i].referenceCountNumber = i + 1 + referenceCountNumber;
      this.temproryselectedProjects[i].quoteprojectordertype_id = 1;
      this.temproryselectedProjects[i].needby_date = '';
      this.temproryselectedProjects[i].note = '';
      this.temproryselectedProjects[i].quoteprojectstatus_id = 0;
      this.temproryselectedProjects[i].recipe_unit_cost = 0;
      this.temproryselectedProjects[i].recipe_nre_cost = 0;
      this.temproryselectedProjects[i].recipe_lot_cost = 0;
      this.temproryselectedProjects[i].defaultRecipe = 0;
      this.temproryselectedProjects[i].quantityBreakDown = [];
      this.temproryselectedProjects[i].margin = 10;

      if (!this.quoteeditMode) {
        let selectedCustomerId = (<HTMLInputElement>document.getElementById('quoteSelectedCustomerId')).value;
        if (selectedCustomerId) {

          this.addDefaultMargin(this.temproryselectedProjects[i], this.customersDict[selectedCustomerId]);

        } else {
          this.temproryselectedProjects[i].margin = this.customersDict[this.temproryselectedProjects[i].customer_id].default_margin;
        }
      } else {
        if (this.selectedProjects.length > 0) {
          this.temproryselectedProjects[i].margin = this.selectedProjects[0].margin;
        } else {

          this.temproryselectedProjects[i].margin = this.customersDict[this.temproryselectedProjects[i].customer_id].default_margin;
        }
      }

      let newRecipe = true;
      this.temproryselectedProjects[i].loadingQuoteprojects = false;
      this.getRecipe(this.temproryselectedProjects[i], this.temproryselectedProjects[i].id, newRecipe, i);

      // not adding duplicate quote project
      let indexOfProject = this.selectedProjects.indexOf(this.temproryselectedProjects[i]);
      if (indexOfProject == -1) {
        this.selectedProjects.push(this.temproryselectedProjects[i]);
      }

    }

    this.temproryselectedProjects = [];
    this.modalAddLineItemAction.emit({ action: 'modal', params: ['close'] });
    // set quote create button to inactive whne line item added
    this.newQuoteButtonStatus = true;

  }

  addLineItemCancel() {
    this.temproryselectedProjects = [];
    this.modalAddLineItemAction.emit({ action: 'modal', params: ['close'] });
  }

  removechip(chip) {
    switch (chip.element) {
      case 'Project Name':
        this.projectNameSearch = undefined;
        break;
      case 'Part Number':
        this.partNumberSearch = undefined;
        break;
      case 'Revision':
        this.revisionSearch = undefined;
        break;
      case 'Material':
        this.materialselectSearch = undefined;
        break;
      case 'Customer':
        this.customerselectSearch = undefined;
        this.customerselect = undefined;
        break;
      case 'Owner':
        this.ownerselectSearch = undefined;
        break;
      case 'Status':
        this.statusselectSearch = undefined;
        break;
      case 'Created within':
        this.numberofDaysSearch = undefined;
        break;
      case 'Date':
        this.createdDateSearch = '1 week';
        break;
      default:
        break;
    }
    this.chipArray.splice(this.chipArray.indexOf(chip));
    this.createAdvancedSearchRequest();
  }


  openEditQuantityModal(recipeId: number) {

    this.currentlySelctedRecipeId = recipeId;

    this.setQuantityBreakDownArrayInput(this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown);

    this.modalEditQuantityAction.emit({ action: 'modal', params: ['open'] });

  }


  getQuantityBreakDownString(quantityArray: any) {
    let quantityString = '';

    for (let i = 0; i < quantityArray.length; i++) {

      quantityString = quantityString + quantityArray[i].quantity;

      if (i + 1 < quantityArray.length) {
        quantityString = quantityString + ',';
      }
    }

    return quantityString;

  }

  setQuantityBreakDownArrayInput(quantityArray: any) {

    let quantityString = this.getQuantityBreakDownString(quantityArray);

    (<HTMLInputElement>document.getElementById('modalEditQuantityInput')).value = quantityString;

  }

  recalculateQuantityBreakDown(stringArray) {
    let quantityBreakDownDict = [];

    for (let j = 0; j < this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown.length; j++) {
      quantityBreakDownDict[this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown[j].quantity] = this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown[j];
    }

    if (this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown.length > stringArray.length) {
      this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown.splice(stringArray.length, this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown.length);
    }
    for (let i = 0; i < stringArray.length; i++) {

      let newdigit: number = parseInt(stringArray[i], 10);

      if (quantityBreakDownDict[newdigit] != undefined && quantityBreakDownDict[newdigit].index === i) {
        continue;
      } else {
        quantityBreakDownDict = [];
        this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown.splice(i, this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown.length);

        // Dev : Aniket
        if (this.recipeDict[this.currentlySelctedRecipeId].amortize_nre) {
          this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown.push(this.manageAccoudingtoAmortizeNRE(this.addQuantityBreakDown(i, newdigit, this.recipeDict[this.currentlySelctedRecipeId].recipe.unit_cost, this.recipeDict[this.currentlySelctedRecipeId].recipe.nre_cost, this.recipeDict[this.currentlySelctedRecipeId].default_margin, this.recipeDict[this.currentlySelctedRecipeId].recipe.lot_cost)));
        } else {

          if (this.recipeDict[this.currentlySelctedRecipeId].exclude_nre) {
            this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown.push(this.addQuantityBreakDown(i, newdigit, this.recipeDict[this.currentlySelctedRecipeId].recipe.unit_cost, 0, this.recipeDict[this.currentlySelctedRecipeId].default_margin, this.recipeDict[this.currentlySelctedRecipeId].recipe.lot_cost));
          } else {
            this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown.push(this.addQuantityBreakDown(i, newdigit, this.recipeDict[this.currentlySelctedRecipeId].recipe.unit_cost, this.recipeDict[this.currentlySelctedRecipeId].recipe.nre_cost, this.recipeDict[this.currentlySelctedRecipeId].default_margin, this.recipeDict[this.currentlySelctedRecipeId].recipe.lot_cost));
          }
        }
      }
    }
  }

  editQuantitySubmit() {

    let quoteQuantityEditString = (<HTMLInputElement>document.getElementById('modalEditQuantityInput')).value;

    let stringArray = quoteQuantityEditString.split(',');

    if (stringArray.length <= 0) {
      // nothing was split
      Materialize.toast('QUANTITIES MUST BE WHOLE NUMBERS SEPARATED BY A COMMA (1,2,5,10,n).', 1500);
      console.log('QUANTITIES MUST BE WHOLE NUMBERS SEPARATED BY A COMMA (1,2,5,10,n).');
      this.setQuantityBreakDownArrayInput(1);
      return;
    }

    for (let i = 0; i < stringArray.length; i++) {
      let newdigit: number = parseInt(stringArray[i], 10);

      if (!this.isWholeNumber(stringArray[i])) {
        Materialize.toast('QUANTITIES MUST BE WHOLE NUMBERS SEPARATED BY A COMMA (1,2,5,10,n).', 1500);
        console.log('QUANTITIES MUST BE WHOLE NUMBERS SEPARATED BY A COMMA (1,2,5,10,n).');
        this.setQuantityBreakDownArrayInput(this.recipeDict[this.currentlySelctedRecipeId].quantityBreakDown);
        return;
      }
    }

    this.recalculateQuantityBreakDown(stringArray);

    this.modalEditQuantityAction.emit({ action: 'modal', params: ['close'] });
  }

  removeQuantityBreakRow(quantityBreakDowns: any, index) {
    quantityBreakDowns.splice(index, 1);
  }

  editQuantityBreakDownvaluesApply(recipeId: number, breakDownIndex: number, currentProject) {
    this.editQuantityBreakDownEndEditmode(recipeId, breakDownIndex, currentProject);
    this.newQuoteButtonStatus = false;
  }

  editQuantityBreakDownvaluesCancel(recipeId: number, breakDownIndex: number, currentProject: any) {

    if (this.recipeDict[recipeId].temporaryQuantityBreakDown) {
      this.recipeDict[recipeId].quantityBreakDown = [];

      this.recipeDict[recipeId].amortize_nre = this.recipeDict[recipeId].temporaryAmortize_nre;
      this.recipeDict[recipeId].exclude_nre = this.recipeDict[recipeId].temporaryExclude_nre;

      if (this.recipeDict[recipeId].amortize_nre) {
        (<HTMLInputElement>document.getElementById('newquoteprojectAmortize_nre' + breakDownIndex)).checked = true;
      } else {
        (<HTMLInputElement>document.getElementById('newquoteprojectAmortize_nre' + breakDownIndex)).checked = false;
      }

      if (this.recipeDict[recipeId].exclude_nre) {
        (<HTMLInputElement>document.getElementById('newquoteprojectExclude_nre' + breakDownIndex)).checked = true;
      } else {
        (<HTMLInputElement>document.getElementById('newquoteprojectExclude_nre' + breakDownIndex)).checked = false;
      }

      for (let i = 0; i < this.recipeDict[recipeId].temporaryQuantityBreakDown.length; i++) {
        this.recipeDict[recipeId].quantityBreakDown.push({
          index: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].index,
          quantity: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].quantity,
          unit_price: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].unit_price,
          nre_price: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].nre_price,
          margin: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].margin,
          lead_time: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].lead_time,
          amount: this.recipeDict[recipeId].temporaryQuantityBreakDown[i].amount
        });
      }
    }

    this.editQuantityBreakDownEndEditmode(recipeId, breakDownIndex, currentProject);
    this.newQuoteButtonStatus = false;
  }

  editQuantityBreakDownvalues(recipeId: number, breakDownIndex: number, currentProject: any) {

    this.newQuoteButtonStatus = true;
    this.recipeDict[recipeId].temporaryQuantityBreakDown = [];
    this.recipeDict[recipeId].temporaryAmortize_nre = this.recipeDict[recipeId].amortize_nre;
    this.recipeDict[recipeId].temporaryExclude_nre = this.recipeDict[recipeId].exclude_nre;

    for (let i = 0; i < this.recipeDict[recipeId].quantityBreakDown.length; i++) {
      this.recipeDict[recipeId].temporaryQuantityBreakDown.push({
        index: this.recipeDict[recipeId].quantityBreakDown[i].index,
        quantity: this.recipeDict[recipeId].quantityBreakDown[i].quantity,
        unit_price: this.recipeDict[recipeId].quantityBreakDown[i].unit_price,
        nre_price: this.recipeDict[recipeId].quantityBreakDown[i].nre_price,
        margin: this.recipeDict[recipeId].quantityBreakDown[i].margin,
        lead_time: this.recipeDict[recipeId].quantityBreakDown[i].lead_time,
        amount: this.recipeDict[recipeId].quantityBreakDown[i].amount
      });
    }

    this.editQuantityBreakDownStartEditmode(recipeId, breakDownIndex, currentProject);
    console.log('editQuantityquantityBreakDownvalues');
  }

  editQuantityBreakDownStartEditmode(recipeId: number, breakDownIndex: number, currentProject: any) {

    (<HTMLInputElement>document.getElementById('editQuoteproject' + breakDownIndex)).style.display = 'none';
    (<HTMLInputElement>document.getElementById('removeQuoteproject' + breakDownIndex)).style.display = 'none';

    (<HTMLInputElement>document.getElementById('newquoteprojectAmortize_nre' + breakDownIndex)).disabled = false;
    (<HTMLInputElement>document.getElementById('newquoteprojectExclude_nre' + breakDownIndex)).disabled = false;
    (<HTMLInputElement>document.getElementById('quantityBreakDownAdd' + breakDownIndex)).disabled = false;

    if ((<HTMLInputElement>document.getElementById('newquoteprojectExclude_nre' + breakDownIndex)).checked) {
      (<HTMLInputElement>document.getElementById('newquoteprojectAmortize_nre' + breakDownIndex)).disabled = true;
    } else {
      (<HTMLInputElement>document.getElementById('newquoteprojectAmortize_nre' + breakDownIndex)).disabled = false;
    }

    if ((<HTMLInputElement>document.getElementById('newquoteprojectAmortize_nre' + breakDownIndex)).checked) {
      (<HTMLInputElement>document.getElementById('newquoteprojectExclude_nre' + breakDownIndex)).disabled = true;
    } else {
      (<HTMLInputElement>document.getElementById('newquoteprojectExclude_nre' + breakDownIndex)).disabled = false;
    }
    currentProject.editmode = true;

    document.getElementById('quantityBreakDownEdit' + breakDownIndex).style.display = 'none';
    document.getElementById('quantityBreakDownEditApply' + breakDownIndex).style.display = 'inline-block';
    document.getElementById('quantityBreakDownEditCancel' + breakDownIndex).style.display = 'inline-block';

  }

  editQuantityBreakDownEndEditmode(recipeId: number, breakDownIndex: number, currentProject: any) {

    (<HTMLInputElement>document.getElementById('newquoteprojectExclude_nre' + breakDownIndex)).disabled = true;
    (<HTMLInputElement>document.getElementById('newquoteprojectAmortize_nre' + breakDownIndex)).disabled = true;
    (<HTMLInputElement>document.getElementById('quantityBreakDownAdd' + breakDownIndex)).disabled = true;

    (<HTMLInputElement>document.getElementById('editQuoteproject' + breakDownIndex)).style.display = 'block';
    (<HTMLInputElement>document.getElementById('removeQuoteproject' + breakDownIndex)).style.display = 'block';

    currentProject.editmode = false;

    document.getElementById('quantityBreakDownEdit' + breakDownIndex).style.display = 'block';
    document.getElementById('quantityBreakDownEditApply' + breakDownIndex).style.display = 'none';
    document.getElementById('quantityBreakDownEditCancel' + breakDownIndex).style.display = 'none';

  }

  onAmortizeNRE(e, project: any, breakDownIndex: number, elementId) {

    let recipeId = project.recipeConnectingID;

    if (e.target.checked) {

      (<HTMLInputElement>document.getElementById(elementId + breakDownIndex)).disabled = true;

      for (let i = 0; i < this.recipeDict[recipeId].quantityBreakDown.length; i++) {

        let index = this.recipeDict[recipeId].quantityBreakDown[i].index;
        if (!index) {
          index = i;
          this.recipeDict[recipeId].quantityBreakDown[i].index = i;
        }

        this.amortizeREEdit_NRE_value_Dict[index] = this.recipeDict[recipeId].quantityBreakDown[i].nre_price;
        this.recipeDict[recipeId].quantityBreakDown[i].unit_price = this.toTwoNumberDecimal(this.recipeDict[recipeId].quantityBreakDown[i].unit_price + (this.recipeDict[recipeId].quantityBreakDown[i].nre_price / this.recipeDict[recipeId].quantityBreakDown[i].quantity));
        this.recipeDict[recipeId].quantityBreakDown[i].nre_price = 0;

      }

      this.recipeDict[recipeId].amortize_nre = 1;

    } else {

      (<HTMLInputElement>document.getElementById(elementId + breakDownIndex)).disabled = false;

      for (let i = 0; i < this.recipeDict[recipeId].quantityBreakDown.length; i++) {

        let index = this.recipeDict[recipeId].quantityBreakDown[i].index;
        if (!index) {
          index = i;
          this.recipeDict[recipeId].quantityBreakDown[i].index = i;
        }

        let nre_price = this.amortizeREEdit_NRE_value_Dict[index];

        if (!nre_price) {
          let nreCost = this.recipeDict[recipeId].recipe.nre_cost;
          let margin = this.recipeDict[recipeId].quantityBreakDown[i].margin;
          nre_price = this.calculateNrePrice(nreCost, margin);
        }

        this.recipeDict[recipeId].quantityBreakDown[i].nre_price = this.toTwoNumberDecimal(nre_price);
        this.recipeDict[recipeId].quantityBreakDown[i].unit_price = this.toTwoNumberDecimal(this.recipeDict[recipeId].quantityBreakDown[i].unit_price - (nre_price / this.recipeDict[recipeId].quantityBreakDown[i].quantity));

      }

      this.recipeDict[recipeId].amortize_nre = 0;
    }
  }


  onExcludeNRE(e, project: any, breakDownIndex: number, elementId) {


    let recipeId = project.recipeConnectingID;

    let unit_cost = this.recipeDict[recipeId].recipe.unit_cost;
    let lot_cost = this.recipeDict[recipeId].recipe.lot_cost;
    if (e.target.checked) {

      (<HTMLInputElement>document.getElementById(elementId + breakDownIndex)).disabled = true;

      for (let i = 0; i < this.recipeDict[recipeId].quantityBreakDown.length; i++) {

        let index = this.recipeDict[recipeId].quantityBreakDown[i].index;
        if (!index) {
          index = i;
          this.recipeDict[recipeId].quantityBreakDown[i].index = i;
        }
        let quantity = this.recipeDict[recipeId].quantityBreakDown[i].quantity;

        this.recipeDict[recipeId].quantityBreakDown[i].amount = this.toTwoNumberDecimal(this.recipeDict[recipeId].quantityBreakDown[i].amount - this.recipeDict[recipeId].quantityBreakDown[i].nre_price);
        this.recipeDict[recipeId].quantityBreakDown[i].nre_price = 0;
        this.recipeDict[recipeId].quantityBreakDown[i].margin = this.toTwoNumberDecimal(this.calculateMargin(quantity, this.recipeDict[recipeId].quantityBreakDown[i].amount, unit_cost, 0, lot_cost));
      }

      this.recipeDict[recipeId].exclude_nre = 1;

    } else {

      (<HTMLInputElement>document.getElementById(elementId + breakDownIndex)).disabled = false;

      for (let i = 0; i < this.recipeDict[recipeId].quantityBreakDown.length; i++) {

        let index = this.recipeDict[recipeId].quantityBreakDown[i].index;

        if (!index) {
          index = i;
          this.recipeDict[recipeId].quantityBreakDown[i].index = i;
        }

        let nreCost = this.recipeDict[recipeId].recipe.nre_cost;
        let margin = this.recipeDict[recipeId].quantityBreakDown[i].margin;
        let nre_price = this.calculateNrePrice(nreCost, margin);
        // New Formula
        this.recipeDict[recipeId].quantityBreakDown[i].nre_price = this.toTwoNumberDecimal(nre_price);
        this.recipeDict[recipeId].quantityBreakDown[i].amount = this.toTwoNumberDecimal(this.recipeDict[recipeId].quantityBreakDown[i].amount + nre_price);
      }
      this.recipeDict[recipeId].exclude_nre = 0;
    }
  }




  //    Calculation logic/ code Dev

  toTwoNumberDecimal(number) {
    return number;
  }


  toInteger(number) {

    if (Number(number) <= 0) {
      return 1;
    }
    return Math.round(  // round to nearest integer
      Number(number)    // type cast your input
    );
  }

  // ON QUNTITY CHANGE

  isWholeNumber(val) {

    if (Number(val) == 0) {
      return false;
    }
    return /^\d+$/.test(val);
  }

  isPositiveNumber(val) {
    return /^[\-]?[\d]*[\.]?[\d]+?$/.test(val);
  }


  on_Time_Change(event, qouteProjectindex, quoteprojectqtyindex, recipeId, qtyelementId) {

    console.log('Event on_Time_Change : ', event.target.value);

    let val = (<HTMLInputElement>document.getElementById(qtyelementId)).value;

    if (this.isWholeNumber(val)) {
      this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].lead_time = Number(val);
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].lead_time;
    } else {
      Materialize.toast('TIME MUST BE POSITIVE NUMBER.', 1500);
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].lead_time;
    }
  }

  on_Qty_Change(event, qouteProjectindex, quoteprojectqtyindex, recipeId, qtyelementId) {
    console.log('Event on_Qty_Change : ', event.target.value);
    let val = (<HTMLInputElement>document.getElementById(qtyelementId)).value;
    if (this.isWholeNumber(val)) {
      this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].quantity = Number(val);
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].quantity;
      this.calculate_on_Qty_Change(quoteprojectqtyindex, recipeId);
    } else {
      Materialize.toast('QUANTITY MUST BE POSITIVE NUMBER.', 1500);
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].quantity;
    }
  }

  calculate_on_Qty_Change(quoteprojectqtyindex, recipeId) {

    let inputQuantity = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].quantity;
    let inputUnitCost = this.recipeDict[recipeId].recipe.unit_cost;
    let inputNreCost = this.recipeDict[recipeId].recipe.nre_cost;
    let inputMargin = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin;
    let inputLotCost = this.recipeDict[recipeId].recipe.lot_cost;

    let unit_price = 0;
    let amount = 0;

    if (this.recipeDict[recipeId].amortize_nre === 1) {
      unit_price = this.calculateUnitPrice(inputQuantity, inputUnitCost, inputNreCost, inputMargin, inputLotCost);
      let nre = this.calculateNrePrice(inputNreCost, inputMargin);
      unit_price = unit_price + (nre / inputQuantity);
      this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price = unit_price;
      this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount = (this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price * inputQuantity);
    } else {

      if (this.recipeDict[recipeId].exclude_nre === 1) {
        unit_price = this.calculateUnitPrice(inputQuantity, inputUnitCost, inputNreCost, inputMargin, inputLotCost);
        amount = (unit_price * inputQuantity);
      } else {
        unit_price = this.calculateUnitPrice(inputQuantity, inputUnitCost, inputNreCost, inputMargin, inputLotCost);
        amount = (unit_price * inputQuantity) + this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].nre_price;
      }
    }

    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price = this.toTwoNumberDecimal(unit_price);
    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount = this.toTwoNumberDecimal(amount);
  }

  on_unit_Change(event, qouteProjectindex, quoteprojectqtyindex, recipeId, qtyelementId) {

    console.log('Event on_unit_Change : ', event.target.value);
    let val = ((<HTMLInputElement>document.getElementById(qtyelementId)).value);

    if (this.isPositiveNumber(val)) {
      this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price = this.toTwoNumberDecimal(Number(val));
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = (this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price);
      this.calculate_on_Unit_Change(quoteprojectqtyindex, recipeId);
    } else {
      Materialize.toast('UNIT PRICE MUST BE A POSITIVE NUMBER.', 1500);
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = (this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price);
    }
  }

  calculate_on_Unit_Change(quoteprojectqtyindex, recipeId) {

    let inputQuantity = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].quantity;
    let inputUnitCost = this.recipeDict[recipeId].recipe.unit_cost;
    let inputNreCost = this.recipeDict[recipeId].recipe.nre_cost;
    let inputMargin = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin;
    let inputLotCost = this.recipeDict[recipeId].recipe.lot_cost;
    let unitPrce = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price;
    let nrePrice = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].nre_price;
    let amount = ((unitPrce * inputQuantity) + nrePrice);
    let margin = 0;
    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount = this.toTwoNumberDecimal(amount);

    if (this.recipeDict[recipeId].amortize_nre === 1) {
      margin = this.calculateMargin(inputQuantity, amount, inputUnitCost, inputNreCost, inputLotCost);
    } else {

      if (this.recipeDict[recipeId].exclude_nre === 1) {
        margin = this.calculateMargin(inputQuantity, amount, inputUnitCost, 0, inputLotCost);
      } else {
        margin = this.calculateMargin(inputQuantity, amount, inputUnitCost, inputNreCost, inputLotCost);
      }
    }
    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin = this.toTwoNumberDecimal(margin);
  }

  on_nre_Change(event, qouteProjectindex, quoteprojectqtyindex, recipeId, qtyelementId) {
    console.log('Event on_nre_Change : ', event.target.value);

    let val = (<HTMLInputElement>document.getElementById(qtyelementId)).value;
    console.log('isPositeveNumberReturn : ', this.isPositiveNumber(val));
    if (this.isPositiveNumber(val)) {
      this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].nre_price = this.toTwoNumberDecimal(Number(val));
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].nre_price;
      this.calculate_on_nre_Change(quoteprojectqtyindex, recipeId);
    } else {
      Materialize.toast('NRE MUST BE A POSITIVE NUMBER.', 1500);
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].nre_price;
    }
  }

  calculate_on_nre_Change(quoteprojectqtyindex, recipeId) {

    let inputQuantity = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].quantity;
    let inputUnitCost = this.recipeDict[recipeId].recipe.unit_cost;
    let inputNreCost = this.recipeDict[recipeId].recipe.nre_cost;
    let inputMargin = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin;
    let inputLotCost = this.recipeDict[recipeId].recipe.lot_cost;
    let unitPrce = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price;
    let nrePrice = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].nre_price;
    let amount = ((unitPrce * inputQuantity) + nrePrice);
    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount = this.toTwoNumberDecimal(amount);
    let margin = this.calculateMargin(inputQuantity, amount, inputUnitCost, inputNreCost, inputLotCost);
    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin = this.toTwoNumberDecimal(margin);

  }

  calculateMargin(inputQuantity: number, amount: number, inputUnitCost: number, inputNreCost: number, inputLotCost: number) {
    inputUnitCost = inputUnitCost - inputLotCost;
    let a = inputUnitCost * inputQuantity;
    return (amount / (inputUnitCost * inputQuantity + inputNreCost + inputLotCost) - 1) * 100;
  }

  on_Margin_Change(event, qouteProjectindex, quoteprojectqtyindex, recipeId, qtyelementId) {
    console.log('Event on_Margin_Change : ', event.target.value);

    let val = ((<HTMLInputElement>document.getElementById(qtyelementId)).value);

    if (this.isPositiveNumber(val)) {
      this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin = this.toTwoNumberDecimal(Number(val));
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = (this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin);
      this.calculate_on_Margin_Change(quoteprojectqtyindex, recipeId);
    } else {
      Materialize.toast('MARGIN MUST BE POSITIVE NUMBER.', 1500);
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = (this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin);
    }
  }

  calculate_on_Margin_Change(quoteprojectqtyindex, recipeId) {

    let inputQuantity = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].quantity;
    let inputUnitCost = this.recipeDict[recipeId].recipe.unit_cost;
    let inputNreCost = this.recipeDict[recipeId].recipe.nre_cost;
    let inputMargin = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin;
    let inputLotCost = this.recipeDict[recipeId].recipe.lot_cost;

    let amount = 0;
    let unit_price = 0;
    let nre_price = 0;

    if (this.recipeDict[recipeId].amortize_nre === 1) {
      unit_price = this.calculateUnitPrice(inputQuantity, inputUnitCost, inputNreCost, inputMargin, inputLotCost);
      let nre_pricelocal = this.calculateNrePrice(inputNreCost, inputMargin);
      unit_price = unit_price + (nre_pricelocal / inputQuantity);
      amount = unit_price * inputQuantity;
      nre_price = 0;
    } else {

      if (this.recipeDict[recipeId].exclude_nre === 1) {
        unit_price = this.calculateUnitPrice(inputQuantity, inputUnitCost, inputNreCost, inputMargin, inputLotCost);
        nre_price = 0;
        amount = unit_price * inputQuantity;
      } else {
        unit_price = this.calculateUnitPrice(inputQuantity, inputUnitCost, inputNreCost, inputMargin, inputLotCost);
        nre_price = (this.calculateNrePrice(inputNreCost, inputMargin));
        amount = (unit_price * inputQuantity) + nre_price;
      }
    }

    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount = this.toTwoNumberDecimal(amount);
    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price = this.toTwoNumberDecimal(unit_price);
    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].nre_price = this.toTwoNumberDecimal(nre_price);
  }

  on_Amount_Change(event, qouteProjectindex, quoteprojectqtyindex, recipeId, qtyelementId) {
    console.log('Event on_Amount_Change : ', event.target.value);
    let val = ((<HTMLInputElement>document.getElementById(qtyelementId)).value);

    if (this.isPositiveNumber(val)) {
      this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount = this.toTwoNumberDecimal(Number(val));
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount;
      this.calculate_on_Amount_Change(quoteprojectqtyindex, recipeId);
    } else {
      Materialize.toast('AMOUNT MUST BE POSITIVE NUMBER.', 1500);
      (<HTMLInputElement>document.getElementById(qtyelementId)).value = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount;
    }
  }

  calculate_on_Amount_Change(quoteprojectqtyindex, recipeId) {

    let inputQuantity = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].quantity;
    let inputUnitCost = this.recipeDict[recipeId].recipe.unit_cost;
    let inputNreCost = this.recipeDict[recipeId].recipe.nre_cost;
    let inputMargin = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin;
    let inputLotCost = this.recipeDict[recipeId].recipe.lot_cost;

    let amount = 0;
    let margin = 0;
    let unit_price = 0;
    let nre_price = 0;

    if (this.recipeDict[recipeId].amortize_nre === 1) {

      amount = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount;
      margin = this.calculateMargin(inputQuantity, amount, inputUnitCost, inputNreCost, inputLotCost);
      nre_price = this.calculateNrePrice(inputNreCost, margin);
      unit_price = this.calculateUnitPrice(inputQuantity, inputUnitCost, inputNreCost, margin, inputLotCost);
      unit_price = unit_price + nre_price / inputQuantity;
      nre_price = 0;
    } else {

      if (this.recipeDict[recipeId].exclude_nre === 1) {
        amount = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount;
        margin = this.calculateMargin(inputQuantity, amount, inputUnitCost, 0, inputLotCost);
        unit_price = this.calculateUnitPrice(inputQuantity, inputUnitCost, 0, margin, inputLotCost);
        nre_price = 0;
      } else {
        amount = this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].amount;
        margin = this.calculateMargin(inputQuantity, amount, inputUnitCost, inputNreCost, inputLotCost);
        nre_price = this.calculateNrePrice(inputNreCost, margin);
        unit_price = this.calculateUnitPrice(inputQuantity, inputUnitCost, inputNreCost, margin, inputLotCost);
      }
    }

    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].margin = this.toTwoNumberDecimal(margin);
    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].nre_price = this.toTwoNumberDecimal(nre_price);
    this.recipeDict[recipeId].quantityBreakDown[quoteprojectqtyindex].unit_price = this.toTwoNumberDecimal(unit_price);

  }

  onNewQuotechnageCustomer() {
    let customer_id = Number((<HTMLInputElement>document.getElementById('quoteSelectedCustomerId')).value);
    let newMargin = this.customerDict[customer_id].default_margin;

    for (let project of this.selectedProjects) {
      project.margin = 10;
    }
  }

  // Calculations --------------------------------------------------------------------------------------------
  addQuantityBreakDown(index: number, inputQuantity: number, inputUnitCost: number, inputNreCost: number, inputMargin: number, inputLotCost: number) {

    // According to new formulas 23-8-2017
    // let presentage = (inputMargin / 100);
    // inputUnitCost = inputUnitCost - inputLotCost;

    let quantityBreakDown = {
      index: index,
      quantity: inputQuantity,
      unit_price: this.calculateUnitPrice(inputQuantity, inputUnitCost, inputNreCost, inputMargin, inputLotCost),
      nre_price: this.calculateNrePrice(inputNreCost, inputMargin),
      margin: inputMargin,
      lead_time: 30,
      amount: 0,
    };

    quantityBreakDown.unit_price = this.toTwoNumberDecimal(quantityBreakDown.unit_price);
    quantityBreakDown.nre_price = this.toTwoNumberDecimal(quantityBreakDown.nre_price);
    quantityBreakDown.amount = this.toTwoNumberDecimal((quantityBreakDown.unit_price * inputQuantity) + quantityBreakDown.nre_price);

    return quantityBreakDown;
  }

  calculateUnitPrice(inputQuantity: number, inputUnitCost: number, inputNreCost: number, inputMargin: number, inputLotCost: number) {

    inputUnitCost = inputUnitCost - inputLotCost;

    return ((inputUnitCost + (inputLotCost / inputQuantity)) * (1 + inputMargin / 100));
  }



  calculateNrePrice(inputNreCost: number, inputMargin: number) {
    return (inputNreCost * (1 + inputMargin / 100));
  }

  calculateNre(inputNreCost: number, inputMargin: number) {
    let nre_price = inputNreCost * (1 + inputMargin / 100);

    return nre_price;
  }



  // Quote details Start -----------------------


  edit_EditQuoteRow(quoteproject: any, index: number) {

    quoteproject.projectEdit = true;
    quoteproject.oldDefaultRecipe = quoteproject.defaultRecipe;

    if (quoteproject.needby_date == '0000-00-00 00:00:00') {
      let date = new Date();
      this.needbydatePlaceholder = this.formatDate(date);
    }

    this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
      if (quoteproject.needby_date != '0000-00-00 00:00:00') {
        let needby_date = this.datePipe.transform(quoteproject.needby_date, 'dd MMMM, yyyy');
        (<HTMLInputElement>document.getElementById('editQuoteProjectDueDateEdit' + index)).value = needby_date;
      }
      (<HTMLInputElement>document.getElementById('editQuoteProjectOrderTypeEdit' + index)).value = quoteproject.quoteprojectordertype_id;
      (<HTMLInputElement>document.getElementById('editQuoteProjectQuoteNoteEdit' + index)).value = quoteproject.note;
      if (quoteproject.defaultRecipe > 0) {
        (<HTMLInputElement>document.getElementById('editQuoteProjectEstimateEdit' + index)).value = quoteproject.defaultRecipe;
      }
    });

    this.startEditQuoteRowEditMode(index);
  }

  edit_cancelEditQuoteRow(quoteproject: any, index: number) {
    quoteproject.projectEdit = false;

    if (quoteproject.oldDefaultRecipe) {
      quoteproject.defaultRecipe = quoteproject.oldDefaultRecipe;
    }
    this.endEditQuoteRowEditMode(index);
  }

  edit_removeQuoteRow(quoteproject: any, index: number) {

    if (this.selectedProjects.length < 2) {
      this.modalDeleteWarningQuoteProjectAction.emit({ action: 'modal', params: ['open'] });
      return;
    }

    let indexOfProject = this.selectedProjects.indexOf(quoteproject);
    this.openModalDeleteQuoteProject(quoteproject, indexOfProject);
  }

  SelectedQuoteUpdated() {
    for (let i = 0; i < this.quotes.length; i++) {
      if (this.selectedQuoteId == this.quotes[i].id) {
        this.quotes[i].updated = 1;
      }
    }
  }

  edit_saveQuoteRow(quoteproject: any, index: number) {

    // function need restructuring
   let recipeId =  quoteproject.recipeConnectingID ;

    if (quoteproject.defaultRecipe < 0) {
      let unit_cost = (<HTMLInputElement>document.getElementById('editUnit_costEdit' + index)).value;
      let nre_cost = (<HTMLInputElement>document.getElementById('editNre_costEdit' + index)).value;
      if (!this.isPositiveNumber(unit_cost)) {
        Materialize.toast('UNIT COST MUST BE A POSITIVE NUMBER.', 1500);
        (<HTMLInputElement>document.getElementById('editUnit_costEdit' + index)).value = '';
        return;
      }
      if (!this.isPositiveNumber(nre_cost)) {
        Materialize.toast('NRE COST MUST BE A POSITIVE NUMBER.', 1500);
        (<HTMLInputElement>document.getElementById('editNre_costEdit' + index)).value = '';
        return;
      }
      this.recipeDict[recipeId].recipe.nre_cost = Number(nre_cost);
      this.recipeDict[recipeId].recipe.unit_cost = Number(unit_cost);
      this.recalculateRecipeQuantityBreakDown(recipeId);
    }

    document.getElementById('editQuoteproject_Updating' + index).style.display = 'block';
    document.getElementById('editQuoteproject_Save' + index).style.display = 'none';
    document.getElementById('editQuoteproject_Cancel' + index).style.display = 'none';

    let quoteprojectquantities = [];

    for (let quantityBreakDown of this.recipeDict[recipeId].quantityBreakDown) {

      let quoteprojectquantity = {
        quantity: quantityBreakDown.quantity,
        unit_price: quantityBreakDown.unit_price,
        nre_price: quantityBreakDown.nre_price,
        margin: quantityBreakDown.margin,
        lead_time: quantityBreakDown.lead_time,
      };

      quoteprojectquantities.push(quoteprojectquantity);
    }

    let dateValue: string = (<HTMLInputElement>document.getElementById('editQuoteProjectDueDateEdit' + index)).value;
    let needby_date;

    if (dateValue.length > 0) {
      needby_date = new Date(dateValue).toISOString();
    }

    if (quoteproject.newProject) {

      quoteproject.newProject = false;

      let updateQuoteProject = {
        project_id: quoteproject.id,
        quote_id: this.selectedQuoteId,
        recipe_id: quoteproject.defaultRecipe,
        quoteprojectordertype_id: (<HTMLInputElement>document.getElementById('editQuoteProjectOrderTypeEdit' + index)).value,
        needby_date: needby_date,
        note: (<HTMLInputElement>document.getElementById('editQuoteProjectQuoteNoteEdit' + index)).value,
        amortize_nre: this.recipeDict[quoteproject.recipeConnectingID].amortize_nre,
        exclude_nre: this.recipeDict[quoteproject.recipeConnectingID].exclude_nre,
        recipe_unit_cost: this.recipeDict[quoteproject.recipeConnectingID].recipe.unit_cost,
        recipe_nre_cost: this.recipeDict[quoteproject.recipeConnectingID].recipe.nre_cost,
        recipe_lot_cost: this.recipeDict[quoteproject.recipeConnectingID].recipe.lot_cost,
      };

      this.quoteService.addQuoteProject(updateQuoteProject, quoteprojectquantities)
        .subscribe(
        data => {
          console.log('Got Recipes');
          let result = JSON.parse(data);
          quoteproject.projectid = quoteproject.id;
          quoteproject.id = result.quoteproject_id;

          Materialize.toast('NEW LINE ITEM ADDED SUCCESSFULLY', 1500);

          this.SelectedQuoteUpdated();

          quoteproject.id =
            this.edit_saveQuoteRowUiChanges(quoteproject, index);
          this.endEditQuoteRowEditMode(index);
        },
        error => {
          Materialize.toast('SERVER ISSUE - PLEASE TRY AGAIN', 1500);
          console.log('SERVER ISSUE - PLEASE TRY AGAIN');
          this.endEditQuoteRowEditMode(index);
        });
    } else {

      let updateQuoteProject = {
        id: quoteproject.id,
        recipe_id: quoteproject.defaultRecipe,
        quoteprojectordertype_id: (<HTMLInputElement>document.getElementById('editQuoteProjectOrderTypeEdit' + index)).value,
        needby_date: needby_date,
        note: (<HTMLInputElement>document.getElementById('editQuoteProjectQuoteNoteEdit' + index)).value,
        amortize_nre: this.recipeDict[quoteproject.recipeConnectingID].amortize_nre,
        exclude_nre: this.recipeDict[quoteproject.recipeConnectingID].exclude_nre,
        recipe_unit_cost: this.recipeDict[quoteproject.recipeConnectingID].recipe.unit_cost,
        recipe_nre_cost: this.recipeDict[quoteproject.recipeConnectingID].recipe.nre_cost,
        recipe_lot_cost: this.recipeDict[quoteproject.recipeConnectingID].recipe.lot_cost,
      };

      this.quoteService.updateQuoteProject(updateQuoteProject, quoteprojectquantities)
        .subscribe(
        data => {
          this.SelectedQuoteUpdated();
          Materialize.toast('QUOTE LINE ITEM UPDATED', 1500);
          this.edit_saveQuoteRowUiChanges(quoteproject, index);
          this.endEditQuoteRowEditMode(index);
        },
        error => {
          Materialize.toast('SERVER ISSUE UPDATING LINE ITEM - PLEASE TRY AGAIN', 1500);
          console.log('SERVER ISSUE UPDATING LINE ITEM - PLEASE TRY AGAIN.');
          this.endEditQuoteRowEditMode(index);
        }
      );
    }
  }

  edit_saveQuoteRowUiChanges(quoteproject: any, index: number) {

    quoteproject.projectEdit = false;

    let needby_date = (<HTMLInputElement>document.getElementById('editQuoteProjectDueDateEdit' + index)).value;

    if (needby_date) {
      quoteproject.needby_date = needby_date;
    }

    let editQuoteProjectEstimateEdit = <HTMLInputElement>document.getElementById('editQuoteProjectEstimateEdit' + index);

    if (editQuoteProjectEstimateEdit != undefined) {
      quoteproject.recipe_id = (<HTMLInputElement>document.getElementById('editQuoteProjectEstimateEdit' + index)).value;
    } else {
      quoteproject.recipe_id = -1;
    }
    quoteproject.quoteprojectordertype_id = (<HTMLInputElement>document.getElementById('editQuoteProjectOrderTypeEdit' + index)).value;
    quoteproject.note = (<HTMLInputElement>document.getElementById('editQuoteProjectQuoteNoteEdit' + index)).value;

  }

  startEditQuoteRowEditMode(index: number) {

    document.getElementById('quoteprojectquantityEdit' + index).className = 'visibility-Hid';

  }

  endEditQuoteRowEditMode(index: number) {

    document.getElementById('quoteprojectquantityEdit' + index).className = 'visibility-Vis';
    document.getElementById('editQuoteproject_Updating' + index).style.display = 'none';

  }

  edit_chnagedefaultRecipe(quoteproject: any, index: any) {

    let val = (<HTMLInputElement>document.getElementById('editQuoteProjectEstimateEdit' + index)).value;
    quoteproject.defaultRecipe = Number(val);
    quoteproject.recipeConnectingID =  this.getRecipeDictconnectingID(quoteproject.defaultRecipe, quoteproject); // quoteproject.recipeConnectingReference;

  }

  // edit_EditQuoteRow End -----------------------

  manageAccoudingtoAmortizeNRE(quantityBreakDown: any) {
    quantityBreakDown.unit_price = this.toTwoNumberDecimal(quantityBreakDown.unit_price + quantityBreakDown.nre_price / quantityBreakDown.quantity);
    quantityBreakDown.nre_price = 0;
    return quantityBreakDown;
  }

  quoteInfoHeaderClicked(quoteId: number) {

    console.log('quoteInfoHeaderClicked');

    if (document.getElementById(quoteId + 'quoteInfoCollapsibleBody').className == 'active') {
      document.getElementById(quoteId + 'quoteInfoArrowRight').style.display = 'none';
      document.getElementById(quoteId + 'quoteInfoArrowDown').style.display = 'block';
      document.getElementById(quoteId + 'quoteInfoEdit').style.display = 'none';

    } else {
      document.getElementById(quoteId + 'quoteInfoArrowRight').style.display = 'block';
      document.getElementById(quoteId + 'quoteInfoArrowDown').style.display = 'none';
      document.getElementById(quoteId + 'quoteInfoEdit').style.display = 'block';
    }
  }


  // EDIT SAVE CANCEL THE WHOLE QUOTE INFO TABLE
  editquoteInfoTable(index) {

    console.log('editquoteInfoTable');

    document.getElementById('customerName' + index).style.display = 'none';
    document.getElementById('customerNameEdit' + index).style.display = 'block';

    document.getElementById('customerQuoteTo' + index).style.display = 'none';
    document.getElementById('customerQuoteToEdit' + index).style.display = 'block';

    document.getElementById('quoteShipVia' + index).style.display = 'none';
    document.getElementById('quoteShipViaEdit' + index).style.display = 'block';

    document.getElementById('quoteTerms' + index).style.display = 'none';
    document.getElementById('quoteTermsEdit' + index).style.display = 'block';

    document.getElementById('quoteExpirationDate' + index).style.display = 'none';
    document.getElementById('quoteExpirationDateEdit' + index).style.display = 'block';

    document.getElementById('quoteEstimatedValue' + index).style.display = 'none';
    document.getElementById('quoteEstimatedValueEdit' + index).style.display = 'block';

    document.getElementById('quoteWinProbability' + index).style.display = 'none';
    document.getElementById('quoteWinProbabilityEdit' + index).style.display = 'block';

    this.customerQinfo_id = this.selectedQuote.customer_id;
    this.customercontactQinfo_id = this.selectedQuote.customercontact_id;
    this.shipviaQinfo_id = this.selectedQuote.shipvia_id;
    this.quoteTermQinfo_id = this.selectedQuote.quoteterms_id;

    document.getElementById(index + 'quoteInfoEdit').style.display = 'none';
    document.getElementById(index + 'quoteInfoSave').style.display = 'inline-block';
    document.getElementById(index + 'quoteInfoCancel').style.display = 'inline-block';
  }

  savequoteInfoTable(index) {

    document.getElementById('customerName' + index).style.display = 'block';
    document.getElementById('customerNameEdit' + index).style.display = 'none';
    this.selectedQuote.customer_id = this.customerQinfo_id;

    document.getElementById('customerQuoteTo' + index).style.display = 'block';
    document.getElementById('customerQuoteToEdit' + index).style.display = 'none';
    this.selectedQuote.customercontact_id = this.customercontactQinfo_id;

    document.getElementById('quoteShipVia' + index).style.display = 'block';
    document.getElementById('quoteShipViaEdit' + index).style.display = 'none';
    this.selectedQuote.shipvia_id = this.shipviaQinfo_id;

    document.getElementById('quoteTerms' + index).style.display = 'block';
    document.getElementById('quoteTermsEdit' + index).style.display = 'none';
    this.selectedQuote.quoteterms_id = this.quoteTermQinfo_id;

    document.getElementById('quoteExpirationDate' + index).style.display = 'block';
    document.getElementById('quoteExpirationDateEdit' + index).style.display = 'none';
    let quoteExpirationDate = (<HTMLInputElement>document.getElementById('quoteExpirationDateEdit' + index)).value;

    if (quoteExpirationDate) {
      this.selectedQuote.expiration_date = new Date(quoteExpirationDate).toISOString();

    }

    document.getElementById('quoteEstimatedValue' + index).style.display = 'block';
    document.getElementById('quoteEstimatedValueEdit' + index).style.display = 'none';
    this.selectedQuote.estimated_quote_value = (<HTMLInputElement>document.getElementById('quoteEstimatedValueEdit' + index)).value;

    document.getElementById('quoteWinProbability' + index).style.display = 'block';
    document.getElementById('quoteWinProbabilityEdit' + index).style.display = 'none';
    this.selectedQuote.win_probability = (<HTMLInputElement>document.getElementById('quoteWinProbabilityEdit' + index)).value;

    console.log('selected quote : ', this.selectedQuote);

    document.getElementById(index + 'quoteInfoEdit').style.display = 'none';
    document.getElementById(index + 'quoteInfoSave').style.display = 'none';
    document.getElementById(index + 'quoteInfoCancel').style.display = 'none';
    document.getElementById(index + 'quoteInfoSpinner').style.display = 'block';

    let updateQuoteInfoDetails = {
      id: this.selectedQuote.id,
      customer_id: this.selectedQuote.customer_id,
      customercontact_id: this.selectedQuote.customercontact_id,
      shipvia_id: this.selectedQuote.shipvia_id,
      quoteterms_id: this.selectedQuote.quoteterms_id,
      estimated_quote_value: this.selectedQuote.estimated_quote_value,
      expiration_date: this.selectedQuote.expiration_date,
      win_probability: this.selectedQuote.win_probability
    };


    console.log('update : ', updateQuoteInfoDetails);

    this.quoteService.updateQuote(updateQuoteInfoDetails)
      .subscribe(
      data => {
        Materialize.toast('QUOTE PROPERTY UPDATE SUCCESSFULLY', 1500);
        console.log('data', data);
        document.getElementById(index + 'quoteInfoEdit').style.display = 'block';
        document.getElementById(index + 'quoteInfoSave').style.display = 'none';
        document.getElementById(index + 'quoteInfoCancel').style.display = 'none';
        document.getElementById(index + 'quoteInfoSpinner').style.display = 'none';
      },
      error => {
        console.log('error', error);
      });

  }


  cancelquoteInfoTable(index) {

    document.getElementById('customerName' + index).style.display = 'block';
    document.getElementById('customerNameEdit' + index).style.display = 'none';

    document.getElementById('customerQuoteTo' + index).style.display = 'block';
    document.getElementById('customerQuoteToEdit' + index).style.display = 'none';

    document.getElementById('quoteShipVia' + index).style.display = 'block';
    document.getElementById('quoteShipViaEdit' + index).style.display = 'none';

    document.getElementById('quoteTerms' + index).style.display = 'block';
    document.getElementById('quoteTermsEdit' + index).style.display = 'none';

    document.getElementById('quoteExpirationDate' + index).style.display = 'block';
    document.getElementById('quoteExpirationDateEdit' + index).style.display = 'none';

    document.getElementById('quoteEstimatedValue' + index).style.display = 'block';
    document.getElementById('quoteEstimatedValueEdit' + index).style.display = 'none';

    document.getElementById('quoteWinProbability' + index).style.display = 'block';
    document.getElementById('quoteWinProbabilityEdit' + index).style.display = 'none';

    document.getElementById(index + 'quoteInfoEdit').style.display = 'block';
    document.getElementById(index + 'quoteInfoSave').style.display = 'none';
    document.getElementById(index + 'quoteInfoCancel').style.display = 'none';
    document.getElementById(index + 'quoteInfoSpinner').style.display = 'none';

  }

  editQuoteInfo(control) {
    document.getElementById(control + 'Value').style.display = 'none';
    document.getElementById(control + 'Edit').style.display = 'block';

    document.getElementById(control + 'Pencil').style.display = 'none';
    document.getElementById(control + 'Apply').style.display = 'block';
    document.getElementById(control + 'Cancel').style.display = 'block';
    this.customerQinfo_id = this.selectedQuote.customer_id;
    this.customercontactQinfo_id = this.selectedQuote.customercontact_id;
    this.shipviaQinfo_id = this.selectedQuote.shipvia_id;
    this.quoteTermQinfo_id = this.selectedQuote.quoteterms_id;

  }

  cancelEditQuoteInfo(control) {
    document.getElementById(control + 'Value').style.display = 'block';
    document.getElementById(control + 'Edit').style.display = 'none';

    document.getElementById(control + 'Pencil').style.display = 'block';
    document.getElementById(control + 'Apply').style.display = 'none';
    document.getElementById(control + 'Cancel').style.display = 'none';
  }

  saveQuoteInfo(control) {
    document.getElementById(control + 'Value').style.display = 'block';
    document.getElementById(control + 'Edit').style.display = 'none';

    this.selectedQuote[control] = (<HTMLInputElement>document.getElementById(control + 'Edit')).value;
    this.selectedQuote.customer_id = this.customerQinfo_id;
    this.selectedQuote.customercontact_id = this.customercontactQinfo_id;
    this.selectedQuote.shipvia_id = this.shipviaQinfo_id;
    this.selectedQuote.quoteterms_id = this.quoteTermQinfo_id;

    console.log('selected quote : ', this.selectedQuote);

    document.getElementById(control + 'Pencil').style.display = 'block';
    document.getElementById(control + 'Apply').style.display = 'none';
    document.getElementById(control + 'Cancel').style.display = 'none';

    if (this.selectedQuote.quoteinfoExpirydate) {
      this.selectedQuote.quoteinfoExpirydate = new Date(this.selectedQuote.quoteinfoExpirydate).toISOString();
    }
    let updateQuoteInfoDetails = {
      id: this.selectedQuote.id,
      customer_id: this.selectedQuote.customer_id,
      customercontact_id: this.selectedQuote.customercontact_id,
      shipvia_id: this.selectedQuote.shipvia_id,
      quoteterms_id: this.selectedQuote.quoteterms_id,
      estimated_quote_value: this.selectedQuote.quoteinfoEstimatedQuote,
      expiration_date: this.selectedQuote.quoteinfoExpirydate,
      win_probability: this.selectedQuote.quoteinfoWinProbability
    };

    this.selectedQuote['estimated_quote_value'] = updateQuoteInfoDetails.estimated_quote_value;
    this.selectedQuote['expiration_date'] = updateQuoteInfoDetails.expiration_date;
    this.selectedQuote['win_probability'] = updateQuoteInfoDetails.win_probability;


    console.log('update : ', updateQuoteInfoDetails);

    this.quoteService.updateQuote(updateQuoteInfoDetails)
      .subscribe(
      data => {
        Materialize.toast('QUOTE PROPERTY UPDATE SUCCESSFULLY', 1000);
        console.log('data', data);
      },
      error => {
        console.log('error', error);
      });

  }

  // method was called but missing from quote html line 641
  editQyantityBreakDownHeaderClicked(i: number) {

    if (document.getElementById('_editQuote_collapsible_body_' + i).className != 'active') {

      document.getElementById('quoteprojectquantityarrowright' + i).style.display = 'none';
      document.getElementById('quoteprojectquantityarrowexpand' + i).style.display = 'block';
      document.getElementById('quoteprojectquantityEdit' + i).style.display = 'block';

    } else {
      document.getElementById('quoteprojectquantityarrowright' + i).style.display = 'block';
      document.getElementById('quoteprojectquantityarrowexpand' + i).style.display = 'none';
      document.getElementById('quoteprojectquantityEdit' + i).style.display = 'none';
    }

    console.log('the method is missing from the component', i);
  }

  openInViewer(id: string, name: string) {
    // Build the URL
    let hwfurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + id + '/' + name + '.hwf';

    console.log('openInViewer() URL: ', hwfurl);
    localStorage.setItem('hwfurl', hwfurl);
    openNewBrowserWindow('/#/viewer', hwfurl);
  }

  sendQuote() {

    this.selectedQuote = this.quoteDict[this.selectedQuoteId];

    this.quotepdfprint = this.selectedQuote;

    for (let i = 0; i < this.quoteprojectsDict[this.selectedQuoteId].length; i++) {

      this.quoteprojectsDict[this.selectedQuoteId][i].quantityBreakDown = [];
      this.quoteprojectsDict[this.selectedQuoteId][i].loadingQuoteprojects = false;
      let newRecipe = false;
      this.quoteprojectsDict[this.selectedQuoteId][i].margin = this.customersDict[this.quoteprojectsDict[this.selectedQuoteId][i].customer_id].default_margin;

      this.getRecipe(this.quoteprojectsDict[this.selectedQuoteId][i], this.quoteprojectsDict[this.selectedQuoteId][i].project_id, newRecipe, i);
    }
  }

  updatePDFQuoteSubmit() {
    this.quotepdfprint = this.selectedQuote;
    let tenantid = this.tenantid;
    let planid = this.planid;
    let quote_id = this.quotepdfprint.id;
    let quotenumber = this.quotepdfprint.quote_number_id;
    let quoteto = {
      customerContact: this.customerContactsDict[this.quotepdfprint.customercontact_id],
      customeremail: this.customerContactEmailDict[this.quotepdfprint.customercontact_id],
      customerphone: this.customerContactPhoneDict[this.quotepdfprint.customercontact_id]
    };

    let city =  this.customersCityDict[this.quotepdfprint.customer_id] + ' ' + this.customerStateDict[this.selectedQuote.customer_id]  + ' ' + this.customerZipDict[this.selectedQuote.customer_id];
    let shipto = {
      customerContact: this.customerContactsDict[this.quotepdfprint.customercontact_id],
      customer: this.customerDict[this.quotepdfprint.customer_id],
      address1: this.customersAddress1Dict[this.quotepdfprint.customer_id],
      address2: this.customersAddress2Dict[this.quotepdfprint.customer_id],
      city: city
    };

    let expiration_date = this.quotepdfprint.expiration_date;
    let create_date = this.quotepdfprint.create_date;
    let terms = this.quotetermDict[this.quotepdfprint.quoteterms_id];
    let Ship_via = this.shipviaDict[this.quotepdfprint.shipvia_id];
    let Sales_Person = this.ownerDict[this.quotepdfprint.owner_id];
    let Sales_Person_contact = this.ownerPhoneDict[this.quotepdfprint.owner_id];
    let websiteurl = globals.WEBSITEURL;

    let dateFormat = this.dateFormat;
    let currencyName = this.currencyName;
    let currencySymbol = this.currencySymbol;
    let lineitems = [];
    if (!this.quotepdfprint.updated) {
      for (let i = 0; i < this.quoteprojectsDict[this.quotepdfprint.id].length; i++) {
        let quoteproject = this.quoteprojectsDict[this.quotepdfprint.id][i];
        let quantityBreakDowns = [];


        for (let k = 0; k < quoteproject.quoteprojectquantities.length; k++) {
          let quantityBreakDown = this.quoteprojectquantitiesDict[quoteproject.quoteprojectquantities[k].id];
          quantityBreakDowns.push({ quantity: quantityBreakDown.quantity, unit_price: quantityBreakDown.unit_price, lead_time: quantityBreakDown.lead_time, nre_price : quantityBreakDown.nre_price, amount: quantityBreakDown.amount });
        }

        let filenamenoext = quoteproject.filename.replace(/\.[^/.]+$/, '');
        if (!filenamenoext) {
          filenamenoext = ' ';
        }
        filenamenoext = filenamenoext.replace(/[+]/g, '%2B');

        let unsecured_quotethumbnail = quoteproject.thumbnail.replace('https://', 'http://');

        lineitems.push({ id: quoteproject.project_id, name: filenamenoext, thumbnailurl: unsecured_quotethumbnail, number: quoteproject.number, revision: quoteproject.revision, description: quoteproject.description, amortize_nre: quoteproject.amortize_nre, exclude_nre: quoteproject.exclude_nre, recipe_nre_cost: quoteproject.recipe_nre_cost, quantityBreakDown: quantityBreakDowns, note: quoteproject.note });
      }
    }
    if (this.quotepdfprint.updated) {
      for (let i = 0; i < this.selectedProjects.length; i++) {
        let quoteproject = this.selectedProjects[i];
        let quantityBreakDowns = [];


        for (let k = 0; k < this.recipeDict[quoteproject.recipeConnectingID].quantityBreakDown.length; k++) {
          let quantityBreakDown = this.recipeDict[quoteproject.recipeConnectingID].quantityBreakDown[k];
          quantityBreakDowns.push({ quantity: quantityBreakDown.quantity, unit_price: quantityBreakDown.unit_price, lead_time: quantityBreakDown.lead_time, amount: quantityBreakDown.amount });
        }

        let filenamenoext = quoteproject.filename.replace(/\.[^/.]+$/, '');
        if (!filenamenoext) {
          filenamenoext = ' ';
        }
        filenamenoext = filenamenoext.replace(/[+]/g, '%2B');

        lineitems.push({ id: quoteproject.project_id, name: filenamenoext, thumbnailurl: quoteproject.thumbnail, number: quoteproject.number, revision: quoteproject.revision, description: quoteproject.description, amortize_nre: quoteproject.amortize_nre, exclude_nre: quoteproject.exclude_nre, recipe_nre_cost: quoteproject.recipe_nre_cost, quantityBreakDown: quantityBreakDowns, note: quoteproject.note });
      }
    }

    let logoURL =  this.tenanturl + '/' +
    this.bucketname +
    '/' +
    this.tenantid +
    '/logo/logo.jpg';

    let unsecuredlogourl = logoURL.replace('https://', 'http://');

    let updateQuoteProject = {
      tenantid: tenantid,
      companyLogoUrl : unsecuredlogourl,
      planid: planid,
      quoteid: quote_id,
      quote_number: quotenumber,
      quote_to: quoteto,
      ship_to: shipto,
      create_date: create_date,
      expiration_date: expiration_date,
      terms: terms,
      Ship_via: Ship_via,
      Sales_Person: Sales_Person,
      Sales_Person_contact: Sales_Person_contact,
      quote_projects: lineitems,
      dateFormat: dateFormat,
      currencyName: currencyName,
      currencySymbol: currencySymbol,
      websiteurl: websiteurl,
      quote_contact_info : this.quote_contact_info,
      quote_document_footer : this.quote_document_footer
    };

    console.log(' PDF QUOTE JSON : ', JSON.stringify(updateQuoteProject));

    this.quoteService.createQuotePDF(updateQuoteProject).subscribe(
      data => {
        let pdfurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/quotes/' + this.selectedQuote.id + '/' + this.selectedQuote.quote_number_id + '.pdf';
        this.showPDF(pdfurl);
      },
      error => {
        console.log('PDF QUOTE CREATION ERROR : ', error);
      }
    );
  }

  saveQuotePDF() {
    let pdf = new jsPDF('p', 'in', [8.5, 11]);
    let element = document.getElementById('pdfcontent');

    element.style.display = 'block';
    pdf.internal.scaleFactor = 3.75;

    let w = element.clientWidth;
    let h = element.clientHeight;
    let ratio = h / w;
    let width = pdf.internal.pageSize.width;
    let height = pdf.internal.pageSize.height;
    let url = this.tenanturl;
    let projectservice = this.projectsService;
    let self = this;

    html2canvas(element, {
      height: h,
      width: w,
      onrendered: function (newCanvas) {
        let imgdata = newCanvas.toDataURL('image/jpeg', 1);
        let height = ratio * width;
        pdf.addImage(newCanvas, 'JPEG', 0, 0, width, height);
        let buffer = pdf.output('blob');

        self.uploadQuoteTos3(buffer, self.quotepdfprint.id, self.quotepdfprint.quote_number_id + '.pdf');

        let blobData = self.dataURItoBlob(imgdata);

        self.uploadQuoteTos3(blobData, self.quotepdfprint.id, self.quotepdfprint.quote_number_id + '.png');
      }
    });
  }

  dataURItoBlob(dataURI) {
    let binary = atob(dataURI.split(',')[1]);
    let array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
  }

  uploadQuoteTos3(databuffer: any, quoteid: number, filename: string) {
    this.s3CredService.getQuoteS3Creds(quoteid)
      .subscribe(
      data => {
        let s3credentials = JSON.parse(data);
        let policy = s3credentials.s3creds.s3Policy;
        let signature = s3credentials.s3creds.s3Signature;
        let serverdate = s3credentials.s3creds.serverDate;
        console.log('policy:', policy);
        console.log('signature:', signature);
        console.log('serverdate:', serverdate);

        let formData: any = new FormData();
        let xhr = new XMLHttpRequest();

        console.log('inside makeFileRequest');

        let todayYMD = serverdate;
        let todayISO = serverdate + 'T000000Z';

        console.log('=>todayISO:', todayISO);
        console.log('=>todayYMD:', todayYMD);
        console.log('=>signature:', signature);
        console.log('=>policy:', policy);

        console.log('=>key:', this.bucketname + '/' + this.tenantid + '/quotes/' + quoteid + '/' + filename);

        formData.append('acl', 'public-read');
        formData.append('Content-Type', 'application/octet-stream');
        formData.append('X-Amz-Date', todayISO);
        formData.append('x-amz-server-side-encryption', 'AES256');
        formData.append('x-amz-meta-uuid', '14365123651274');
        formData.append('X-Amz-Algorithm', 'AWS4-HMAC-SHA256');

        formData.append('X-Amz-Credential', 'AKIAIOFP5KTDKSWJUH3Q/' + todayYMD + '/us-west-2/s3/aws4_request');

        formData.append('X-Amz-Signature', signature);
        formData.append('Policy', policy);


        formData.append('key', this.bucketname + '/' + this.tenantid + '/quotes/' + quoteid + '/' + filename);

        formData.append('file', databuffer);

        console.log('Form data appended');

        xhr.onreadystatechange = () => {
          if (xhr.readyState == 4) {
            if (xhr.status == 200) {
              // console.log
              // resolve(JSON.parse(xhr.response));
              //   this.progresses[0].currentValue = 100;
            } else if (xhr.status == 204) {
              // resolve(true);
              //   this.progresses[0].currentValue = 100;
            } else {
              // reject(xhr.response);
            }
          }
        };
        xhr.open('POST', this.tenanturl, true);
        xhr.send(formData);


      },
      error => {
        console.log('error', error);
      });
  }

  openModalDeleteQuote(selectedQuote: any, index: number) {
    this.selectedQuoteId = selectedQuote.id;
    this.selectedQuoteNumberId = selectedQuote.quote_number_id;
    this.quoteindextodelete = index;
    this.modalDeleteQuoteAction.emit({ action: 'modal', params: ['open'] });
  }

  loadMoreProjects() {
    this.loadingprojects = true;

    this.config.currentPage =  this.config.currentPage + 1;

    this.advancedSearchProjecCall();
  }

  deleteQuoteConfirm() {
    this.waiticon = 'fa right fa-spinner fa-pulse';

    console.log('selectedquote ID:', this.selectedQuoteId);

    this.quoteService.deleteQuote(this.selectedQuoteId).subscribe(
      data => {
        try {
          let json = JSON.parse(data);

          if (json == true) {
            this.waiticon = '';
            Materialize.toast('QUOTE DELETED SUCCESSFULLY.', 1500);
            console.log('QUOTE DELETED SUCCESSFULLY');

            this.quotes.splice(this.quoteindextodelete, 1);
            this.modalDeleteQuoteAction.emit({ action: 'modal', params: ['close'] });
          } else {
            console.log('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN');
            Materialize.toast('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN', 1500);
            this.waiticon = '';
          }
        } catch (e) {
          console.log('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN');
          Materialize.toast('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN', 1500);
          this.waiticon = '';
        }
      },
      error => {
        console.log('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN');
        Materialize.toast('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN', 1500);
        this.waiticon = '';
      });
  }

  openModalDeleteQuoteProject(quoteproject: any, index: any) {
    this.selectedQuoteProject = quoteproject;
    this.selectedQuoteProject.index = index;
    this.modalDeleteQuoteProjectAction.emit({ action: 'modal', params: ['open'] });
  }

  deleteQuoteProjectCancel() {
    this.modalDeleteWarningQuoteProjectAction.emit({ action: 'modal', params: ['close'] });
  }

  deleteQuoteProjectConfirm() {
    this.waiticon = 'fa right fa-spinner fa-pulse';

    this.quoteService.deleteQuoteProject(this.selectedQuoteProject.id).subscribe(
      data => {
        try {
          let json = JSON.parse(data);

          if (json == true) {
            this.waiticon = '';
            Materialize.toast('PROJECT LINE ITEM REMOVED SUCCESSFULLY', 1500);
            console.log('PROJECT LINE ITEM REMOVED SUCCESSFULLY');

            if (this.selectedQuoteProject.index != -1) {
              this.selectedProjects.splice(this.selectedQuoteProject.index, 1);
            }

            this.modalDeleteQuoteProjectAction.emit({ action: 'modal', params: ['close'] });
          } else {
            console.log('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN');
            Materialize.toast('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN', 1500);
            this.waiticon = '';
          }
        } catch (e) {
          console.log('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN');
          Materialize.toast('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN', 1500);
          this.waiticon = '';
        }
      },
      error => {
        console.log('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN');
        Materialize.toast('SERVER ERROR WHILE DELETING QUOTE - PLEASE TRY AGAIN', 1500);
        this.waiticon = '';
      });
  }

  getBase64Image(img) {
    let canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    let ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    let dataURL = canvas.toDataURL('image/png');
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
  }

  advancedSearchQuote(searchString, advSearch = 1) {
    console.log('advancedSearchProject : ' + searchString);
    this.loadingquotes = true;
    this.quoteService.advancedSearchQuote(this.quoteconfig, searchString, advSearch)
      .subscribe(
      data => {
        console.log('Got Quotes');
        this.LoadedSelectedProjectsCount = 0;
        let result = JSON.parse(data);
        console.log('Recipes : ', result);
        this.quotes = result.quotes;
        this.customers = result.customers;
        this.customerContacts = result.customercontacts;
        this.quotes = result.quotes;
        this.owners = result.owners;
        this.materialArray = result.materials;
        this.quoteprojects = result.quoteprojects;
        this.quoteprojectquantities = result.quoteprojectquantities;
        this.quoteprojectstatuses = result.quoteprojectstatuses;
        this.leadtimeunits = result.leadtimeunits;
        this.quoteprojectordertypes = result.quoteprojectordertypes;
        this.quotestatuses = result.quotestatuses;
        this.comments = result.comments;
        this.commenttypes = result.commenttypes;
        this.shipvias = result.shipvia;
        this.quoteterms = result.quoteterms;

        this.quoteconfig.currentPage = Number(result.pagenum);
        this.quoteconfig.totalItems = Number(result.count);

        this.addProjectData();

        for (let i = 0; i < this.materialArray.length; i++) {
          this.materialDict[this.materialArray[i].id] = this.materialArray[i].name;
        }

        for (let i = 0; i < this.quotes.length; i++) {
          this.quotes[i].updated = 0;
          this.quoteDict[this.quotes[i].id] = this.quotes[i];
        }

        for (let i = 0; i < this.owners.length; i++) {
          this.ownerDict[this.owners[i].id] = this.owners[i].firstname + ' ' + this.owners[i].lastname;
          this.ownerPhoneDict[this.owners[i].id] = this.owners[i].phone;
        }

        for (let i = 0; i < this.customers.length; i++) {
          this.customerDict[this.customers[i].id] = this.customers[i].name;
          this.customercontactDict[this.customers[i].id] = this.customers[i].primary_contact_id;
          this.customersAddress1Dict[this.customers[i].id] = this.customers[i].address;
          this.customersAddress2Dict[this.customers[i].id] = this.customers[i].address2;
          this.customersCityDict[this.customers[i].id] = this.customers[i].city;
          this.customerStateDict[this.customers[i].id] = this.customers[i].state;
          this.customerZipDict[this.customers[i].id] = this.customers[i].zip;
        }

        for (let i = 0; i < this.quotestatuses.length; i++) {
          this.quotestatusesDict[this.quotestatuses[i].id] = this.quotestatuses[i].name;
        }

        for (let i = 0; i < this.customerContacts.length; i++) {
          this.customerContactsDict[this.customerContacts[i].id] = this.customerContacts[i].firstname + ' ' + this.customerContacts[i].lastname;
          this.customerContactEmailDict[this.customerContacts[i].id] = this.customerContacts[i].email;
          this.customerContactPhoneDict[this.customerContacts[i].id] = this.customerContacts[i].phone;
        }

        for (let i = 0; i < this.quoteprojectordertypes.length; i++) {
          this.quoteprojectordertypesDict[this.quoteprojectordertypes[i].id] = this.quoteprojectordertypes[i].name;
        }

        for (let i = 0; i < this.shipvias.length; i++) {
          this.shipviaDict[this.shipvias[i].id] = this.shipvias[i].name;
        }

        for (let i = 0; i < this.quoteterms.length; i++) {
          this.quotetermDict[this.quoteterms[i].id] = this.quoteterms[i].name;
        }

        let customerContactsArray = [];

        for (let i = 0; i < this.customers.length; i++) {
          this.customersDict[this.customers[i].id] = this.customers[i];

          for (let j = 0; j < this.customerContacts.length; j++) {

                if (this.customerContacts[j].customer_id == this.customers[i].id) {
                          customerContactsArray.push(this.customerContacts[j]);
                        }
                 }
           this.customersWithcustomerContactsDict[this.customers[i].id] = customerContactsArray;
           customerContactsArray = [];
        }

        for (let i = 0; i < this.quoteprojectquantities.length; i++) {
          this.quoteprojectquantities[i].amount = ((this.quoteprojectquantities[i].unit_price * this.quoteprojectquantities[i].quantity) + this.quoteprojectquantities[i].nre_price);
          this.quoteprojectquantities[i].exclude_nre = 0;
          this.quoteprojectquantities[i].amortize_nre = 0;
          this.quoteprojectquantitiesDict[this.quoteprojectquantities[i].id] = this.quoteprojectquantities[i];
        }

        let quoteProjectsArray = [];

        for (let i = 0; i < this.quotes.length; i++) {
          for (let j = 0; j < this.quoteprojects.length; j++) {

            if (this.quoteprojects[j].quote_id == this.quotes[i].id) {
              quoteProjectsArray.push(this.quoteprojects[j]);
            }
          }
          this.quoteprojectsDict[this.quotes[i].id] = quoteProjectsArray;
          quoteProjectsArray = [];
        }

        if (result.count == 0) {
          this.emptySearchProjects = true;
          this.waiticon = '';
          this.loadingprojects = false;
        } else {
          this.emptySearchProjects = false;
        }

        for (let i = 0; i < this.comments.length; i++) {
          this.commentsDict[this.comments[i].id] = this.comments[i];
        }

        // temp values
        this.quotestatusesDict[0] = 'Unknown';
        this.ownerDict[0] = 'Unknown';
        this.quoteprojectordertypesDict[0] = 'Unknown';

        this.loadingquotes = false;

        for (let i = 0; i < this.quotes.length; i++) {

          if (this.quoteprojectsDict[this.quotes[i].id].length) {
            this.quotes[i].thumbnail = this.quoteprojectsDict[this.quotes[i].id][0].thumbnail;
          } else {
            this.quotes[i].thumbnail = '../assets/images/doctypes/pdf.png';
          }
        }
      },
      error => {
        this.loadingquotes = false;
      });
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/quote/quote.component.ts